import { ChangeDetectorRef, Component, EventEmitter, ViewChildren, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ElementRef, QueryList, OnDestroy, NgZone } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { ShareValuesService } from '../../../../services/sharedValues/share-values.service';
import { TranslateService } from '@ngx-translate/core';
import { BackendCallService } from '../../../../services/backend-call/backend-call.service';
import { ToastService } from 'src/app/services/toast.service';
import { SubSection } from '../../service-roadmaps/roadmap-interface';
import { AppConstants, ObservationEvents, StorageKeys } from 'src/app/utilities/constant';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { LanguageSupportService } from 'src/app/services/language-support.service';
import { addUniqueEntry,isNotEmptyArray } from '../../../../utilities/utils';
import { UserAuthService } from 'src/app/services/user-auth/user-auth.service';
import { ConfirmationModalComponent } from 'src/app/components/confirmation-modal/confirmation-modal.component';
import { GraphService } from 'src/app/services/graph/graph.service';
import { EventProvider } from 'src/app/services/event';
import { SubSink } from 'subsink';
import { ConfirmationService } from 'src/app/services/confirmation.service';
import { StatusPopoverComponent } from 'src/app/components/status-popover/status-popover.component';
import { CopyRoadmapComponent } from '../copy-roadmap/copy-roadmap.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { SectionRenameComponent } from 'src/app/components/section-rename/section-rename.component';
import { Location } from '@angular/common';
import { MachineModeConflictComponent } from 'src/app/components/machine-mode-conflict/machine-mode-conflict.component';
import { AiWritingService } from 'src/app/services/ai-writing/ai-writing.service';
import { AiWritingHistoryService, HistoryEntry } from 'src/app/services/ai-writing/ai-writing-history.service';
import { AiHistoryModalComponent } from 'src/app/components/ai-history-modal/ai-history-modal.component';
import { ImageEditorService } from 'src/app/services/image-editor/image-editor.service';
import { UploadConfirmationModalComponent, UploadConfirmationResult } from 'src/app/components/upload-confirmation-modal/upload-confirmation-modal.component';
import { ImageUploadEvent } from 'src/app/shared/components/image-upload/image-upload.component';
import { AiAdjustBarComponent } from 'src/app/components/ai-adjust-bar/ai-adjust-bar.component';

interface RoadmapSection {
  title: string;
  content: string;
}
interface RoadmapSectionDetails {
  createdDate: string;
  id: string;
  sectionId: string;
  sectionName: string;
  SubSections?: SubSection[]
}
@Component({
  selector: 'roadmap-view-create',
  templateUrl: './roadmap-view-create.component.html',
  styleUrls: ['./roadmap-view-create.component.scss'],
})
export class RoadmapViewCreateComponent implements OnInit,OnChanges, OnDestroy {
public sections = [];
// AI functionality on this screen is controlled by the user's assigned
// Proofreading permission rather than a deployment-level flag.
public get aiFeaturesEnabled(): boolean {
  return this.userAuthService.hasPermission('PROOFREADING');
}
public selectedSection: any;
public selectedIndex: number = 0;
@Input() isReadonlyRoadmap: boolean = false;
@Input() readOnlyRoadmapData: any;
@Input() fromLibrary : boolean = false;
@Input() roadmapName : string = '';
@Input() sectionList: any = {};
@Input() sectionDetails: any = {};
@Input() roadmapId: string;
@Input() serviceMachineId : string = '';
@Input() project_id : string = '';
@Input() isCustom: boolean;
@Input() isMachineBased: boolean;
@Input() isRoadmapCopied: boolean = false;
@Input() roadmapList: any;
@Input() isAnsweredRoadmap: boolean;
@Output() addHazardDetail = new EventEmitter<boolean>();
@Output() editHazardDetails = new EventEmitter<boolean>();
@ViewChildren('sectionInput') sectionInputs!: QueryList<ElementRef<HTMLInputElement>>;
selectedLanguage: string = this.serviceMulti.getDefaultLanguage();
public accordionOpen = false;
public question: any;
public notes: any;
public compliance: any;
public subSections = [];
public sectionId : number;
public roadmapStatus: number;
public isRiskReassessment: boolean;
@Output() exitEvent = new EventEmitter<boolean>();
@Output() viewRoadmapConfigurationEvent = new EventEmitter<boolean>();
public reviewImageSrc: string | ArrayBuffer;
public previewCompliantImages: any[]=[];
public previewNotCompliantImages: any[]=[];
public imageFiles: File[];
private readonly MAX_ROADMAP_IMAGE_SIZE = 5242880;
public currentIndex = 0;
private activePointerCarouselType: 'compliant' | 'notCompliant' | null = null;
private carouselPointerStartX = 0;
private carouselPointerStartScrollLeft = 0;
public hazardImages = [];
complianceOptions = [
  { value: 'yesCompliant', label: 'Yes, Compliant' },
  { value: 'notCompliant', label: 'Not Compliant' },
  { value: 'notApplicable', label: 'Not applicable' }
];
@ViewChildren(AiAdjustBarComponent) adjustBars?: QueryList<AiAdjustBarComponent>;

activeAdjust: {
  step: any;
  subSection: any;
  field: 'stepBody' | 'stepNotes';
  error: string;
  applied: boolean;
  appliedSkillId: string;
} | null = null;
hazardRatingList = [
  {
    listName: 'Probability of Occurrence', 
    listNameView: '', // This will be set in updateLanguage method
    weightagesList: [], // This will be set in updateLanguage method
    dataChrn: {}, 
    dataRiskChrn: {}, 
    dataRiskIhrn: {}, 
    dataIhrn: {}, 
    rating: '',
    val: 'PO'
  },
  {
    listName: 'Frequency of Exposition',
    listNameView: '', 
    weightagesList: [], 
    dataChrn: {}, 
    dataRiskChrn: {}, 
    dataRiskIhrn: {}, 
    dataIhrn: {}, 
    rating: '',
    val: 'FE'
  },
  {
    listName: 'Degree of Severity',
    listNameView: '', 
    weightagesList: [], 
    dataChrn: {}, 
    dataRiskChrn: {}, 
    dataRiskIhrn: {}, 
    dataIhrn: {}, 
    rating: '',
    val: 'SD'
  },
  {
    listName: 'Number of Persons Exposed',
    listNameView: '', 
    weightagesList: [], 
    dataChrn: {}, 
    dataRiskChrn: {}, 
    dataRiskIhrn: {}, 
    dataIhrn: {}, 
    rating: '',
    val : 'NP'
  }
];private userInfo: {
  name: string; userId: string; email: string; jobTitle: string; isGlobalAdmin: boolean; profileData: {}; permissions: any[]; // this.initailizeFroala();
}; 
imageSrc: any;
queryParams: any={};
machineImagesList = [];
hazardImagesList = [];
optionMapping: { [key: string]: { answer: number, class: string, value: string } } = {
  'Yes, Compliant': { answer: 1, class: 'yes-compliant', value: 'yesCompliant' },
  'Not applicable': { answer: 3, class: 'not-applicable', value: 'notApplicable' },
  'Report Hazard': { answer: 4, class: 'hazard-background', value: 'hazard' },
  'Not Compliant': { answer: 2, class: 'not-compliant', value: 'notCompliant' }
};
public isSaveDisabled = true;
public isAddingSection = false;
public isAddingSubSection = false;
public isAddingStep = false;
public subs = new SubSink();
public hasEmptySelectedValue: boolean;
public copiedHazard: any = [];

public isLoading = true;
public viewRoadmapData: any;
public isReadonlyHazard: boolean = false;
public roadmapType: string;
public isTemplateRoadmap: boolean = false;
public originalRoadmapName: string = '';
private pendingFocusTarget: {
  field: 'subsection-name' | 'step-body' | 'step-notes' | 'step-answer' | 'image-upload';
  subSectionKey: string;
  stepKey?: string;
  imageType?: string;
  imageKey?: string;
} | null = null;
private pendingImageRestore: {
  subSectionKey: string;
  stepKey?: string;
  imageType?: string;
  imageKey?: string;
  imageControl?: 'name' | 'remove' | 'upload';
  imageIndex?: number;
} | null = null;
private latestImageFocusTarget: {
  subSectionKey: string;
  stepKey?: string;
  imageType?: string;
  imageKey?: string;
  imageControl?: 'name' | 'remove' | 'upload';
  imageIndex?: number;
} | null = null;
private imageRestoreInProgress = false;
private imageRestoreObserver: MutationObserver | null = null;
private pendingRoadmapImageUpload: {
  files: File[];
  type: 'compliant' | 'notCompliant';
  step: any;
  subSection: any;
  selectedSection: any;
} | null = null;
private isPreservingExternalTarget = false;
private roadmapLocalChangeSeq = 0;
private subSectionNameOnFocus = new Map<string, string>();
private stepBodyOnFocus = new Map<string, string>();
private stepNotesOnFocus = new Map<string, string>();

// Breadcrumb tracking for currently open step
public currentBreadcrumb: {
  sectionName: string;
  subSectionName: string;
  stepName: string;
  isVisible: boolean;
} = {
  sectionName: '',
  subSectionName: '',
  stepName: '',
  isVisible: false
};

private machineDetails: any;
private selectedRoadmapList: any=[];
@ViewChild('rightScrollContainer') rightScrollContainer: ElementRef;
private lastRightScrollTop = 0;
private pendingHazardReturnState: { scrollTop: number; stepId: string } | null = null;
public checkedRoadMapList: any = [];
private machineId: any;
constructor(
  private modalController: ModalController,
  public sharedValue: ShareValuesService,
  public translate: TranslateService,
  public backendService: BackendCallService,
  private toastService: ToastService,
  private serviceMulti: LanguageSupportService,
  public userAuthService: UserAuthService,
  private graphService: GraphService,
  private route: ActivatedRoute,
  public sharedService: ShareValuesService,
  private eventProvider: EventProvider,
  private confirmationService: ConfirmationService,
  public popoverController: PopoverController,
  private changeDetectorRef: ChangeDetectorRef,
  private location: Location,
  private router: Router,
  private ngZone: NgZone,
  private aiWritingService: AiWritingService,
  private aiHistory: AiWritingHistoryService,
  private imageEditorService: ImageEditorService,
) {
  this.route.queryParams.subscribe(async (params) => {
    this.queryParams=params;
    this.project_id = params.project_id;
    this.machineDetails = JSON.parse(params?.machineDetails);
  }); 
  this.userInfo = this.userAuthService.getUserList();
}


ngOnDestroy() {
  this.updateHazardOverlayClass(false);
  sessionStorage.removeItem(StorageKeys.READONLY_ROADMAP_DATA);
  this.subs.unsubscribe();
  window.removeEventListener('scroll', this.onWindowScroll, true);
  window.removeEventListener('focusin', this.onGlobalFocusIn, true);
  window.removeEventListener('pointerdown', this.onGlobalPointerDown, true);
  window.removeEventListener('keydown', this.onGlobalKeyDown, true);
  this.imageRestoreObserver?.disconnect();
  if (this.selectionRafId != null) {
    cancelAnimationFrame(this.selectionRafId);
  }
  if (this.aiPhraseTimer) {
    clearInterval(this.aiPhraseTimer);
  }
  if (this.aiComposingPhraseTimer) {
    clearInterval(this.aiComposingPhraseTimer);
  }
}

// Both bubbles should track their anchored text/field through a scroll,
// not stay pinned to the screen while the content scrolls out from under
// them — so this recomputes position rather than dismissing on scroll.
// capture:true catches scrolling on any nested container (e.g.
// .subsection-block), not just the window. Coalesced into one recompute
// per animation frame so a fast scroll gesture doesn't force a layout
// calculation on every tick.
private onWindowScroll = (): void => {
  if ((!this.lastSelection && !this.generateBubble) || this.selectionRafId != null) return;
  this.selectionRafId = requestAnimationFrame(() => {
    this.selectionRafId = null;
    if (this.lastSelection) this.positionSelectionToolbar();
    // Only reposition an ALREADY-open bubble — generateBubbleAnchor alone
    // just means "this empty field is a candidate" (see openGenerateBubble
    // below); scrolling shouldn't be what pops it open.
    if (this.generateBubble) this.positionGenerateBubble();
  });
};

machineModeList: any = [];
private getMachineModesList() {    
    this.backendService
      .getMachineLimitsByServiceMachineId(this.machineDetails.machine_Id, this.selectedLanguage)
      .subscribe(
        (data: any) => {
          const existingValues = new Set(
            this.machineModeList.map(m => m.value.toLowerCase())
          );          
          const newModes = data.response;            
          this.machineModeList = [...this.machineModeList, ...newModes];  
         }
      );
  }  

updateLanguage(language: string): void {
  const listNameMappings = {
    'Probability of Occurrence': {
      en: 'Likelihood Of Occurences (LO)',
      de: 'Eintrittswahrscheinlichkeit (LO)',
      sp: 'Probabilidad de ocurrencia (LO)',
      pt: 'Probabilidade de ocorrência (LO)',
    },
    'Frequency of Exposition': {
      en: 'Frequency Of Exposure (FE)',
      de: 'Häufigkeit der Gefährdung (FE)',
      sp: 'Frecuencia de exposición (FE)',
      pt: 'Frequência de exposição (FE)',
    },
    'Degree of Severity': {
      en: 'Degree Of Possible Harm (DPH)',
      de: 'Schweregrad der Verletzung (DPH)',
      sp: 'Grado de daño posible (DPH)',
      pt: 'Grau de dano possível (DPH)',
    },
    'Number of Persons Exposed': {
      en: 'Number of Persons at Risk (NPE)',
      de: 'Anzahl der gefährdeten Personen (NPE)',
      sp: 'Número de personas en riesgo (NPE)',
      pt: 'Número de pessoas em risco (NPE)',
    }
  };

  const weightageListMappings = {
    'Probability of Occurrence': {
      en: this.sharedValue.weightagesList,
      de: this.sharedValue.weightagesListGermanLng,
      sp: this.sharedValue.weightagesListSpanishLang,  // Spanish uses the same list as English for now
      pt: this.sharedValue.weightagesListPotugueseLang,  // Portuguese uses the same list as English for now
    },
    'Frequency of Exposition': {
      en: this.sharedValue.FEweightagesList,
      de: this.sharedValue.FEweightagesGermanLng,
      sp: this.sharedValue.FEweightagesSpanishLang,  // Spanish uses the same list as English
      pt: this.sharedValue.FEweightagesPortugueseLang,  // Portuguese uses the same list as English
    },
    'Degree of Severity': {
      en: this.sharedValue.DPEweightagesList,
      de: this.sharedValue.DPEweightagesListGermanLng,
      sp: this.sharedValue.DPEweightagesListSpanishLang,  // Spanish uses the same list as English
      pt: this.sharedValue.DPEweightagesListPortugueseLang,  // Portuguese uses the same list as English
    },
    'Number of Persons Exposed': {
      en: this.sharedValue.NPEweightagesList,
      de: this.sharedValue.NPEweightagesList,
      sp: this.sharedValue.NPEweightagesList,  // Spanish uses the same list as English
      pt: this.sharedValue.NPEweightagesList,  // Portuguese uses the same list as English
    }
  };

  // Loop through the hazardRatingList and update listNameView and weightagesList based on the selected language
  this.hazardRatingList.forEach(item => {
    item.listNameView = listNameMappings[item.listName][language] || '';
    item.weightagesList = weightageListMappings[item.listName][language] || [];
  });
}

ngOnChanges(_changes: SimpleChanges): void {
  this.updateLanguage(this.selectedLanguage);     
  this.selectedIndex = 0;
  this.selectedSection = this.sectionList?.[0] ? this.sectionList?.[0] : this.sections[0];     
  this.sections = this.sectionList;
  this.subSections = this.sectionDetails;
  if (this.isAnsweredRoadmap) {
    this.isTemplateRoadmap = true;
  }
}

public async showRoadmapGrid(){
  const isConfirmed = await this.confirmationService.presentConfirmationModal(this.translate.instant('Are you sure you want to exit?'), AppConstants.EXIT,true);
  if (isConfirmed) {
      this.exitEvent.emit(true);
  }
}

ngOnInit() {
  this.sharedValue.getControlMeasureType();
  this.sharedValue.getConformityStatus();
  this.sharedService.getHazardDropdownData();
  this.getMachineModesList();
  // The selection bubble is position:fixed (needed to escape this page's
  // overflow:hidden panels), so it needs help tracking the text through a
  // scroll. capture:true catches scrolling on any nested container, e.g.
  // .subsection-block, not just the window.
  window.addEventListener('scroll', this.onWindowScroll, true);
  window.addEventListener('focusin', this.onGlobalFocusIn, true);
  window.addEventListener('pointerdown', this.onGlobalPointerDown, true);
  window.addEventListener('keydown', this.onGlobalKeyDown, true);
  setTimeout(() => {
    const stored = sessionStorage.getItem(StorageKeys.READONLY_ROADMAP_DATA);
    if (stored) {
      try {
        this.viewRoadmapData = JSON.parse(stored);
        console.log(this.viewRoadmapData, 'READONLY_ROADMAP_DATA');
        this.originalRoadmapName = this.roadmapName;
        if (this.viewRoadmapData) {
          this.roadmapName = this.viewRoadmapData.roadmapName;
          this.roadmapId = this.viewRoadmapData.roadmapId;
          this.roadmapStatus = this.viewRoadmapData.roadmapStatus;
          this.isCustom = this.viewRoadmapData.isCustom;
          this.serviceMachineId = this.viewRoadmapData.serviceMachineId;
          this.isMachineBased = this.viewRoadmapData.isMachineBased;
          this.isMachineBased = true;
          this.isReadonlyRoadmap = this.viewRoadmapData.isReadonlyRoadmap;
          this.isReadonlyHazard = this.viewRoadmapData.isReadonlyRoadmap; // Also set isReadonlyHazard
          this.sectionDetails = this.viewRoadmapData.sectionDetails;
          this.sectionList = this.viewRoadmapData.sectionList;
          this.sections = this.viewRoadmapData.sectionList;
          this.subSections = this.viewRoadmapData.sectionDetails;
          this.isTemplateRoadmap = this.viewRoadmapData.isTemplateRoadmap;
          this.machineId = this.viewRoadmapData.machineId;
          this.updateHazardOverlayClass(true);
          this.selectedRoadmapList.push(this.roadmapId);
          this.changeDetectorRef.detectChanges();
          // Don't remove sessionStorage immediately - keep it for potential refreshes
          // sessionStorage.removeItem(StorageKeys.READONLY_ROADMAP_DATA);
        }
      } catch (error) {
        console.error('Error parsing READONLY_ROADMAP_DATA:', error);
      }
    }
  }, 1000);
  this.isLoading = false;
  
  setTimeout(() => {
    if (this.isMachineBased) {
      this.complianceOptions.push({ value: 'hazard', label: 'Report Hazard' })
    }
  }, 1500);
  this.previewCompliantImages = [];
  this.previewNotCompliantImages = [];
}
/**
 * Deletes hazard localy
 * 
 * @param data 
 * @param hazardId 
 */
private deleteHazardLocally(data, hazardId) {
    data.steps.forEach(step => {
      step.hazard = step.hazard.filter(hazard => hazard.id !== hazardId);
    });     
    console.log('Hazard Deleted Locally:', data);
    this.subSections = data;
    this.changeDetectorRef.detectChanges();
}
/**
 * Deletes roadmap confirmation
 * 
 * @param hazard 
 */
  public deleteHazard(hazard, i, step) {
    const payload = {
      modifiedBy: this.userAuthService.getUserList().userId,
      machineHazardId: hazard.id,
      hazardName: hazard.name,
    }

    this.backendService.deleteHazard(payload).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.backendService.roadmapExecution(this.roadmapId,this.sections[this.selectedIndex].sectionId,this.fromLibrary).subscribe(async (res: any) => {
          if ((res.statusCode === 200)) {     
            this.applyRoadmapExecutionResponse(res.response);
            this.toggleStepAccordion(step);      
            this.changeDetectorRef.detectChanges();
          }
        });                
        this.toastService.presentToast('Hazard Deleted Successfully', 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
      }
    }, err => {
      this.toastService.presentToast('Something went wrong', 4000, AppConstants.ERROR_SNACKBAR, 'top');
    });
  }

  /**
   * Deletes hazard confirmation
   * 
   * @param hazard 
   */
  async deleteHazardConfirmation(hazard, i, step){
    const itemName = this.translate.instant('hazard').toLowerCase();
    const title = this.translate.instant('Are_you_sure_you_want_to_delete') + ' ' + itemName + '?';
    const subtitle = hazard?.hazardName ? `'${hazard.hazardName}'` : null;
    console.log(hazard,'asdfaf')
    const actionText = this.translate.instant('Delete');
    const isConfirmed = await this.confirmationService.presentConfirmationModal(
      title,
      actionText,
      true,
      this.translate.instant('Cancel'),
      subtitle
    );
    if (isConfirmed) {
      this.deleteHazard(hazard, i, step);
    }
  }

isDuplicateRoadmapName: boolean = false;
public changeRoadmapName(ev) {
  if(!(this.roadmapName == ''))
  {
    if(this.validateDuplicateRoadmapName(this.roadmapName,this.roadmapId,this.roadmapList))  
      this.isDuplicateRoadmapName = true;  
    else
      this.isDuplicateRoadmapName = false
  }
}

public onRoadmapNameBlur() {
  if (this.roadmapName === this.originalRoadmapName) {
    this.toastService.presentToast(this.translate.instant('roadmap_name_already_exists'), 4000, AppConstants.ERROR_SNACKBAR, AppConstants.TOP);
    return;
  }
  if (this.selectedSection && this.roadmapName !== '' && !this.isDuplicateRoadmapName) {
    this.onSave(null, null, this.selectedSection);
  }
}

private notifySaveInProgress(): void {
  this.toastService.presentToast(
    this.translate.instant('saving_changes_wait_before_switching_pages'),
    2500,
    AppConstants.WARNING_SNACKBAR,
    AppConstants.TOP
  );
}

private startCreateLock(type: 'section' | 'subSection' | 'step'): boolean {
  if (type === 'section') {
    if (this.isAddingSection) {
      this.notifySaveInProgress();
      return false;
    }
    this.isAddingSection = true;
    return true;
  }

  if (type === 'step') {
    if (this.isAddingStep) {
      this.notifySaveInProgress();
      return false;
    }
    this.isAddingStep = true;
    return true;
  }

  if (this.isAddingSubSection) {
    this.notifySaveInProgress();
    return false;
  }

  this.isAddingSubSection = true;
  return true;
}

private releaseCreateLock(saveContext?: 'add-section' | 'add-subsection' | 'add-step'): void {
  if (saveContext === 'add-section') {
    this.isAddingSection = false;
  }

  if (saveContext === 'add-subsection') {
    this.isAddingSubSection = false;
  }

  if (saveContext === 'add-step') {
    this.isAddingStep = false;
  }
}

public addSection() {
  if (this.roadmapName === '') {
    this.toastService.presentToast(this.translate.instant('empty-roadmap-msg'), 4000, AppConstants.WARNING_SNACKBAR, 'top');
    return;
  }

  if (!this.startCreateLock('section')) {
    return;
  } else {
    if (!Array.isArray(this.sections)) {
      this.sections = [];
    }
    if(!this.sections.length) {
      this.originalRoadmapName = this.roadmapName;
    }
    const newSection: any = {
      sectionId: '',
      sectionName: this.getNextUniqueSectionName(),
      subSections: [],
      hasEmptySelectedValue: true
    };
    this.isSaveDisabled = false
    this.sections.push(newSection);
    this.onSave(null,null,newSection, undefined, undefined, 'add-section');
    this.selectSection(this.sections.length - 1);
  }
}

/**
 * Deletes section
 * 
 * @param section section
 * @param index index
 * @param event event
 */
public deleteSection(section, index: number, event: Event) {
  event.stopPropagation();
  this.selectedSection = null;
  this.selectedIndex = null;
  let sectionId: any;
  if(section.sectionId){
    this.sections.forEach((element, i) => {
      if (element.sectionId == section.sectionId) {
        sectionId = element.sectionId;
        this.sections.splice(index, 1);
      }
    });
    if(this.fromLibrary)
    {
      const payload = {
        type: 'section',
        id: section.sectionId
      };
      this.backendService.deleteTemplateRoadmap(payload).subscribe(
        (data: any) => {
          if (data.statusCode == 200) {
            this.toastService.presentToast(
              this.translate.instant('customer_management_deleted_successfully', { entity: this.translate.instant('Section') }),
              4000,
              AppConstants.SUCCESS_SNACKBAR,
              'top'
            );
            this.selectSection(index- 1);  
            this.onSave(null,null,this.sections[this.selectedIndex]);
          } else {
            this.toastService.presentToast(
              this.translate.instant('customer_management_delete_failed', { entity: this.translate.instant('Section') }),
              4000,
              AppConstants.ERROR_SNACKBAR,
              'top'
            );
          }          
        },
        err => {
          this.toastService.presentToast(err.message, 4000, AppConstants.ERROR_SNACKBAR, 'top', 'error_occurred');
        }
      );
    }
    else
    {
    const payload = {
      id: this.roadmapId,
      serviceMachineId: this.serviceMachineId,
      projectId: this.project_id,
      section: [{
        sectionId: sectionId,
        isDelete: true,
        subSection: [{
          subSection_Id: '',
          isDelete: false,
          steps: [{
            id: '',
            isDelete: false
          }]
        }]
      }]
    };
    this.backendService.deleteRoadmapSectionsData(payload).subscribe(
      (data: any) => {
        this.toastService.presentToast(
          this.translate.instant('customer_management_deleted_successfully', { entity: this.translate.instant('Section') }),
          4000,
          AppConstants.SUCCESS_SNACKBAR,
          'top'
        );
      },
      err => {
        this.toastService.presentToast(err.message, 4000, AppConstants.ERROR_SNACKBAR, 'top', 'error_occurred');
      }
    );
   }
  }else {
    this.sections.splice(index, 1);
  }

}

/**
 * Selects section
 * 
 * @param index 
 */
public selectSection(index: number) {
  if(this.isAnsweredRoadmap){
    this.isTemplateRoadmap = this.isAnsweredRoadmap;
  }
  this.selectedIndex = index;
  this.selectedSection = this.sections[index];  
  const sectionId = this.selectedSection?.sectionId === "" ? null : this.selectedSection?.sectionId;
  setTimeout(() => this.focusInputAtIndex(index), 0);
  if(this.roadmapId !== '') { // for new roadmaps   
    this.backendService.roadmapExecution(this.roadmapId, sectionId, this.isTemplateRoadmap)
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.sections = data.response.sectionList;
            this.subSections = data.response.sectionDetails; 
            this.changeDetectorRef.detectChanges();
            setTimeout(() => this.focusInputAtIndex(this.selectedIndex), 0);         
          }
        },
        error: (err) => {
          console.error('Error in roadmap execution:', err);
        }
      });
  }
}
selectSectionOnClick(event: MouseEvent, index: number): void {
  this.selectSection(index);
}
private focusInputAtIndex(index: number): void {
  console.log(this.sectionInputs,'selectSectionOnClick');
  if (this.sectionInputs) {
    const inputArray = this.sectionInputs.toArray();
    if (inputArray[index]) {
      inputArray[index].nativeElement.focus();
    } else {
       console.log('Input element not found at index:', index);
    }
  } else {
       console.log('sectionInputs QueryList not available.');
  }
}


public onSectionNameChanged(event: FocusEvent, section: any): void {
  event.stopPropagation();
  section.sectionName = String(section?.sectionName || '').trim();

  if (this.hasDuplicateName('section', section.sectionName, section)) {
    this.showDuplicateNameToast('section');
    this.changeDetectorRef.detectChanges();
    return;
  }

  this.onSave(null,null,section);  
}
public selectAndFocusSection(event: MouseEvent, index: number, inputElement: HTMLInputElement): void {
  event.stopPropagation();
  this.selectSection(index);
  // Set focus on the input element after a small delay
  setTimeout(() => {
    inputElement.focus();
  }, 0);
}

onNotesChanged(this){}

onStepBodyChanged(this){}

private getSubSectionKey(subSection: any): string {
  return String(subSection?.subSectionId || subSection?.id || subSection?.subSectionName || '');
}

private normalizeRoadmapName(value: any): string {
  return String(value || '').trim().toLowerCase();
}

private showDuplicateNameToast(type: 'section' | 'subsection' | 'step'): void {
  const translationKeyMap = {
    section: 'section_name_already_exists',
    subsection: 'subsection_name_already_exists',
    step: 'step_name_already_exists'
  };
  const message = this.translate.instant(translationKeyMap[type]);
  this.toastService.presentToast(message, 4000, AppConstants.ERROR_SNACKBAR, 'top');
}

private hasDuplicateName(type: 'section' | 'subsection', candidateName: string, currentItem?: any): boolean {
  return type === 'section'
    ? this.isDuplicateSectionName(candidateName, currentItem)
    : this.isDuplicateSubSectionName(candidateName, currentItem);
}

private isDuplicateSectionName(candidateName: string, currentSection?: any): boolean {
  const normalizedCandidate = this.normalizeRoadmapName(candidateName);
  if (!normalizedCandidate) {
    return false;
  }

  return (this.sections || []).some((section) => {
    if (section === currentSection) {
      return false;
    }

    const sameId = (currentSection?.sectionId || currentSection?.id) &&
      (section?.sectionId || section?.id) === (currentSection?.sectionId || currentSection?.id);
    if (sameId) {
      return false;
    }

    return this.normalizeRoadmapName(section?.sectionName) === normalizedCandidate;
  });
}

private isDuplicateStepName(candidateName: string, subSection?: any, currentStep?: any): boolean {
  const normalizedCandidate = this.normalizeRoadmapName(candidateName);
  if (!normalizedCandidate || !Array.isArray(subSection?.steps)) {
    return false;
  }

  return subSection.steps.some((step) => {
    if (step === currentStep) {
      return false;
    }

    const currentId = currentStep?.stepId || currentStep?.id;
    const stepId = step?.stepId || step?.id;
    if (currentId && stepId === currentId) {
      return false;
    }

    return this.normalizeRoadmapName(step?.stepBody) === normalizedCandidate;
  });
}

private isDuplicateSubSectionName(candidateName: string, currentSubSection?: any): boolean {
  const normalizedCandidate = this.normalizeRoadmapName(candidateName);
  if (!normalizedCandidate) {
    return false;
  }

  return (this.subSections || []).some((subSection) => {
    if (subSection === currentSubSection) {
      return false;
    }

    const currentId = currentSubSection?.subSectionId || currentSubSection?.subSection_Id || currentSubSection?.id;
    const subSectionId = subSection?.subSectionId || subSection?.subSection_Id || subSection?.id;
    if (currentId && subSectionId === currentId) {
      return false;
    }

    return this.normalizeRoadmapName(subSection?.subSectionName) === normalizedCandidate;
  });
}

private getNextUniqueSectionName(): string {
  let index = (this.sections?.length || 0) + 1;
  let candidate = `New Section ${index}`;

  while (this.isDuplicateSectionName(candidate)) {
    index++;
    candidate = `New Section ${index}`;
  }

  return candidate;
}

private getNextUniqueSubSectionName(): string {
  let index = (this.subSections?.length || 0) + 1;
  let candidate = `Sub Section ${index}`;

  while (this.isDuplicateSubSectionName(candidate)) {
    index++;
    candidate = `Sub Section ${index}`;
  }

  return candidate;
}

private getNextUniqueStepName(subSection: any): string {
  let index = (subSection?.steps?.length || 0) + 1;
  let candidate = `New Step ${index}`;

  while (this.isDuplicateStepName(candidate, subSection)) {
    index++;
    candidate = `New Step ${index}`;
  }

  return candidate;
}

private getStepKey(step: any): string {
  return String(step?.stepId || step?.id || step?.stepBody || '');
}

private rememberPendingFocus(
  field: 'subsection-name' | 'step-body' | 'step-notes' | 'step-answer' | 'image-upload',
  subSection: any,
  step?: any,
  imageType?: number | string,
  image?: any
): void {
  this.saveRightScrollPosition();
  this.pendingFocusTarget = {
    field,
    subSectionKey: this.getSubSectionKey(subSection),
    stepKey: step ? this.getStepKey(step) : undefined,
    imageType: imageType !== undefined ? String(imageType) : undefined,
    imageKey: image ? this.getMediaKey(image) : undefined,
  };
}

private moveCaretToEnd(targetElement: any): void {
  const applySelection = (element: HTMLInputElement | HTMLTextAreaElement | null | undefined) => {
    if (!element || typeof element.setSelectionRange !== 'function') {
      return;
    }
    const valueLength = element.value?.length ?? 0;
    element.setSelectionRange(valueLength, valueLength);
    requestAnimationFrame(() => {
      const nextLength = element.value?.length ?? valueLength;
      element.setSelectionRange(nextLength, nextLength);
    });
  };

  if (targetElement instanceof HTMLInputElement || targetElement instanceof HTMLTextAreaElement) {
    applySelection(targetElement);
    return;
  }

  if (typeof targetElement.getInputElement === 'function') {
    targetElement.getInputElement().then((element: HTMLInputElement | HTMLTextAreaElement) => {
      applySelection(element);
    }).catch(() => undefined);
    return;
  }

  applySelection(targetElement.querySelector?.('input, textarea'));
}

private findTargetElement(
  container: HTMLElement,
  target: {
    field: 'subsection-name' | 'step-body' | 'step-notes' | 'step-answer' | 'image-upload';
    subSectionKey: string;
    stepKey?: string;
    imageType?: string;
    imageKey?: string;
    imageControl?: string;
  }
): HTMLElement | null {
  const candidates = Array.from(
    container.querySelectorAll(`[data-focus-field="${target.field}"]`)
  ) as HTMLElement[];

  return candidates.find((element) => {
    const subSectionKey = element.getAttribute('data-subsection-key');
    const stepKey = element.getAttribute('data-step-key');
    const imageType = element.getAttribute('data-image-type');
    const imageKey = element.getAttribute('data-image-key');
    const imageControl = element.getAttribute('data-image-control');

    return subSectionKey === target.subSectionKey &&
      (target.stepKey === undefined || stepKey === target.stepKey) &&
      (target.imageType === undefined || imageType === target.imageType) &&
      (target.imageKey === undefined || imageKey === target.imageKey) &&
      (target.imageControl === undefined || imageControl === target.imageControl);
  }) || null;
}

private restorePendingImageFocus(): void {
  if (!this.pendingImageRestore || this.imageRestoreInProgress || !this.rightScrollContainer?.nativeElement) {
    return;
  }

  this.imageRestoreInProgress = true;
  const container = this.rightScrollContainer.nativeElement as HTMLElement;
  if (!this.imageRestoreObserver) {
    this.imageRestoreObserver = new MutationObserver(() => {
      if (!this.pendingImageRestore) {
        return;
      }
      this.imageRestoreInProgress = false;
      requestAnimationFrame(() => this.restorePendingImageFocus());
    });
    this.imageRestoreObserver.observe(container, { childList: true, subtree: true });
  }
  const delays = [300, 500, 800, 1200, 1600];
  let restored = false;

  this.ngZone.runOutsideAngular(() => {
    delays.forEach((delay) => {
      setTimeout(() => {
        if (restored) {
          return;
        }

        requestAnimationFrame(() => {
          if (restored) {
            return;
          }

          const currentRestoreTarget = this.latestImageFocusTarget || this.pendingImageRestore;
          if (!currentRestoreTarget) {
            restored = true;
            this.imageRestoreInProgress = false;
            return;
          }

          const target = {
            field: 'image-upload' as const,
            ...currentRestoreTarget,
          };
          const targetElement = this.findTargetElement(container, target) ||
            this.findImageNameFallback(container, target);
          if (!targetElement) {
            return;
          }

          const imageControl = target.imageControl || 'name';
          if (imageControl === 'remove') {
            targetElement.setAttribute('tabindex', '0');
          }
          targetElement.focus({ preventScroll: true });
          if (imageControl !== 'remove') {
            this.moveCaretToEnd(targetElement);
          }

          requestAnimationFrame(() => {
            const activeElement = document.activeElement;
            const isFocused = activeElement === targetElement || targetElement.contains(activeElement);
            if (!isFocused && imageControl === 'remove') {
              targetElement.focus({ preventScroll: true });
              return;
            }

            restored = true;
            this.imageRestoreInProgress = false;
            this.restoreRightScrollPosition();
          });
        });

        if (delay === delays[delays.length - 1] && !restored) {
          this.imageRestoreInProgress = false;
        }
      }, delay);
    });
  });
}

public onRoadmapImageRendered(): void {
  if (!this.pendingImageRestore) {
    return;
  }

  this.imageRestoreInProgress = false;
  requestAnimationFrame(() => requestAnimationFrame(() => this.restorePendingImageFocus()));
}

private findImageNameFallback(
  container: HTMLElement,
  target: { subSectionKey: string; stepKey?: string; imageType?: string; imageKey?: string; imageControl?: string; imageIndex?: number }
): HTMLElement | null {
  if (target.imageControl === 'remove') {
    return null;
  }

  const candidates = Array.from(container.querySelectorAll('.image-name-input')) as HTMLElement[];
  const imageNameInput = candidates.find((element) =>
    element.getAttribute('data-subsection-key') === target.subSectionKey &&
    (target.stepKey === undefined || element.getAttribute('data-step-key') === target.stepKey) &&
    (target.imageType === undefined || element.getAttribute('data-image-type') === target.imageType) &&
    (target.imageKey === undefined || element.getAttribute('data-image-key') === target.imageKey)
  );
  if (imageNameInput) {
    return imageNameInput;
  }

  if (target.imageIndex !== undefined) {
    const matchingInputs = candidates.filter((element) =>
      element.getAttribute('data-subsection-key') === target.subSectionKey &&
      (target.stepKey === undefined || element.getAttribute('data-step-key') === target.stepKey) &&
      (target.imageType === undefined || element.getAttribute('data-image-type') === target.imageType)
    );
    if (matchingInputs[target.imageIndex]) {
      return matchingInputs[target.imageIndex];
    }
  }

  const uploadHost = Array.from(container.querySelectorAll('[data-focus-field="image-upload"]'))
    .find((element: Element) =>
      element.getAttribute('data-subsection-key') === target.subSectionKey &&
      (target.stepKey === undefined || element.getAttribute('data-step-key') === target.stepKey) &&
      (target.imageType === undefined || element.getAttribute('data-image-type') === target.imageType) &&
      (target.imageKey === undefined || element.getAttribute('data-image-key') === target.imageKey)
    ) as HTMLElement | undefined;
  if (target.imageControl === 'remove' && target.imageIndex !== undefined) {
    const matchingRemoveIcons = Array.from(container.querySelectorAll('[data-image-control="remove"]'))
      .filter((element: Element) =>
        element.getAttribute('data-subsection-key') === target.subSectionKey &&
        (target.stepKey === undefined || element.getAttribute('data-step-key') === target.stepKey) &&
        (target.imageType === undefined || element.getAttribute('data-image-type') === target.imageType)
      );
    return matchingRemoveIcons[target.imageIndex] as HTMLElement || null;
  }

  return target.imageControl === 'upload'
    ? uploadHost?.querySelector('.upload-box-container') as HTMLElement | null
    : null;
}


private rememberImageRestoreTarget(subSection: any, step: any, type: number, image: any, imageControl: string = 'name'): void {
  const imageIndex = this.getOrderedStepMedia(step, type === 5)
    .findIndex((currentImage: any) => currentImage === image || this.getMediaKey(currentImage) === this.getMediaKey(image));
  const target = {
    subSectionKey: this.getSubSectionKey(subSection),
    stepKey: this.getStepKey(step),
    imageType: String(type),
    imageKey: this.getMediaKey(image),
    imageControl: imageControl as 'name' | 'remove' | 'upload',
    imageIndex: imageIndex >= 0 ? imageIndex : undefined,
  };
  this.pendingImageRestore = target;
  this.latestImageFocusTarget = target;
}

public onImageControlFocus(
  image: any,
  type: number,
  step: any,
  subSection: any,
  imageControl: 'name' | 'remove'
): void {
  this.rememberImageRestoreTarget(subSection, step, type, image, imageControl);
}

private replaceArrayContents<T>(target: T[], items: T[] = []): void {
  target.length = 0;
  target.push(...items);
}

private reconcileArrayByKey<T>(
  current: T[],
  incoming: T[],
  getKey: (item: T) => string,
  mergeItem: (existing: T, next: T) => void
): void {
  const existingMap = new Map<string, T>();
  current.forEach((item) => existingMap.set(getKey(item), item));

  const mergedItems = incoming.map((item) => {
    const key = getKey(item);
    const existing = existingMap.get(key);
    if (!existing) {
      return item;
    }
    mergeItem(existing, item);
    return existing;
  });

  this.replaceArrayContents(current, mergedItems);
}

private getMediaKey(media: any): string {
  return String(media?.id || media?.url || media?.fileName || '');
}

private getRoadmapImageNameFromOrder(orderNo: number): string {
  return `Image ${orderNo}`;
}

private syncStepMediaOrderAndNames(step: any): void {
  const media = Array.isArray(step?.media) ? step.media : [];

  [true, false].forEach((isCompliant) => {
    const imagesOfType = media.filter((img: any) => this.isMediaForCompliance(img, isCompliant));

    imagesOfType.forEach((img: any, index: number) => {
      const orderNo = this.getMediaOrderNo(img, index);
      img.orderNo = orderNo;

      // Preserve the stored fileName as the source of truth. A default-looking
      // name such as "Image 8" is still a valid user label, and should not be
      // overwritten simply because the backend orderNo is different.
      const fileName = String(img?.fileName ?? '').trim();
      if (!fileName) {
        img.fileName = this.getRoadmapImageNameFromOrder(orderNo);
      }
    });
  });
}

private mergeStepMedia(existingStep: any, incomingStep: any): void {
  const currentMedia = Array.isArray(existingStep?.media) ? existingStep.media : [];
  this.reconcileArrayByKey(currentMedia, incomingStep?.media || [], (media) => this.getMediaKey(media), (existing, next) => {
    Object.assign(existing, next);
  });
  existingStep.media = currentMedia;
  this.syncStepMediaOrderAndNames(existingStep);
}

private mergeStepData(existingStep: any, incomingStep: any, preserveLocalValues = false): void {
  const wasOpen = !!existingStep?.accordionOpen;
  const currentHazards = Array.isArray(existingStep?.hazard) ? existingStep.hazard : [];
  const localStepValues = preserveLocalValues ? {
    answer: existingStep?.answer,
    selectedValue: existingStep?.selectedValue,
    selectColorClass: existingStep?.selectColorClass,
    stepBody: existingStep?.stepBody,
    stepNotes: existingStep?.stepNotes,
    stepNote: existingStep?.stepNote,
    stepNotesChange: existingStep?.stepNotesChange,
    stepNotesInvalid: existingStep?.stepNotesInvalid,
    padLock: existingStep?.padLock,
    media: existingStep?.media,
  } : null;

  Object.assign(existingStep, incomingStep);
  existingStep.accordionOpen = wasOpen;

  if (localStepValues) {
    Object.assign(existingStep, localStepValues);
  } else {
    this.mergeStepMedia(existingStep, incomingStep);
  }

  if (Array.isArray(incomingStep?.hazard)) {
    this.reconcileArrayByKey<any>(currentHazards, incomingStep.hazard, (hazard: any) => String(hazard?.id || hazard?.hazardName || ''), (existing: any, next: any) => {
      Object.assign(existing, next);
    });
    existingStep.hazard = currentHazards;
  }
}

private mergeSubSectionData(existingSubSection: any, incomingSubSection: any, preserveLocalValues = false): void {
  const currentSteps = Array.isArray(existingSubSection?.steps) ? existingSubSection.steps : [];
  const localSubSectionName = existingSubSection?.subSectionName;
  Object.assign(existingSubSection, incomingSubSection);
  if (preserveLocalValues) {
    existingSubSection.subSectionName = localSubSectionName;
  }
  this.reconcileArrayByKey(currentSteps, incomingSubSection?.steps || [], (step) => this.getStepKey(step), (existing, next) => {
    this.mergeStepData(existing, next, preserveLocalValues);
  });
  existingSubSection.steps = currentSteps;
}

private applyRoadmapExecutionResponse(response: any, preserveLocalValues = false): void {
  const sectionList = response?.sectionList || [];
  const sectionDetails = response?.sectionDetails || [];
  const currentSections = Array.isArray(this.sections) ? this.sections : (this.sections = []);
  const currentSubSections = Array.isArray(this.subSections) ? this.subSections : (this.subSections = []);

  this.reconcileArrayByKey(currentSections, sectionList, (section) => String(section?.sectionId || section?.id || section?.sectionName || ''), (existing, next) => {
    const localSectionName = existing?.sectionName;
    Object.assign(existing, next);
    if (preserveLocalValues) {
      existing.sectionName = localSectionName;
    }
  });
  this.reconcileArrayByKey(currentSubSections, sectionDetails, (subSection) => this.getSubSectionKey(subSection), (existing, next) => {
    this.mergeSubSectionData(existing, next, preserveLocalValues);
  });

  if (this.selectedIndex >= 0) {
    this.selectedSection = currentSections[this.selectedIndex];
  }
}

private restorePendingFocus(): void {
  if (!this.pendingFocusTarget || !this.rightScrollContainer?.nativeElement) {
    return;
  }

  const pendingTarget = this.pendingFocusTarget;
  const container = this.rightScrollContainer.nativeElement as HTMLElement;
  this.pendingFocusTarget = null;

  this.ngZone.runOutsideAngular(() => {
    const tryRestore = (attempt: number) => {
      this.restoreRightScrollPosition();

      const candidates = Array.from(
        container.querySelectorAll(`[data-focus-field="${pendingTarget.field}"]`)
      ) as HTMLElement[];
      const targetElement = candidates.find((element) => {
        const subSectionKey = element.getAttribute('data-subsection-key');
        const stepKey = element.getAttribute('data-step-key');
        const imageType = element.getAttribute('data-image-type');
        const imageKey = element.getAttribute('data-image-key');

        return subSectionKey === pendingTarget.subSectionKey &&
          (pendingTarget.stepKey === undefined || stepKey === pendingTarget.stepKey) &&
          (pendingTarget.imageType === undefined || imageType === pendingTarget.imageType) &&
          (pendingTarget.imageKey === undefined || imageKey === pendingTarget.imageKey);
      });

      if (!targetElement) {
        if (attempt < 12) {
          requestAnimationFrame(() => tryRestore(attempt + 1));
        }
        return;
      }

      const focusableElement = targetElement as any;
      const finalizeRestore = () => {
        this.moveCaretToEnd(focusableElement);
        requestAnimationFrame(() => {
          this.moveCaretToEnd(focusableElement);
          this.restoreRightScrollPosition();
        });
      };

      if (typeof focusableElement.setFocus === 'function') {
        Promise.resolve(focusableElement.setFocus()).finally(finalizeRestore);
      } else {
        targetElement.focus();
        finalizeRestore();
      }
    };

    requestAnimationFrame(() => tryRestore(0));
  });
}

private rememberPendingFocusFromTarget(target: EventTarget | null): boolean {
  const element = target instanceof HTMLElement ? target : null;
  const focusElement = element?.closest?.('[data-focus-field]') as HTMLElement | null;
  if (!focusElement) {
    return false;
  }

  const field = focusElement.getAttribute('data-focus-field') as 'subsection-name' | 'step-body' | 'step-notes' | 'step-answer' | 'image-upload' | null;
  const subSectionKey = focusElement.getAttribute('data-subsection-key') || '';
  if (!field || !subSectionKey) {
    return false;
  }

  this.isPreservingExternalTarget = true;
  this.saveRightScrollPosition();
  this.pendingFocusTarget = {
    field,
    subSectionKey,
    stepKey: focusElement.getAttribute('data-step-key') || undefined,
    imageType: focusElement.getAttribute('data-image-type') || undefined,
    imageKey: focusElement.getAttribute('data-image-key') || undefined,
  };

  this.pendingImageRestore = field === 'image-upload'
    ? {
        subSectionKey,
        stepKey: focusElement.getAttribute('data-step-key') || undefined,
        imageType: focusElement.getAttribute('data-image-type') || undefined,
        imageKey: focusElement.getAttribute('data-image-key') || undefined,
        imageControl: (focusElement.getAttribute('data-image-control') || 'name') as 'name' | 'remove' | 'upload',
        imageIndex: this.getImageFocusIndex(focusElement),
      }
    : null;

  this.latestImageFocusTarget = field === 'image-upload'
    ? this.pendingImageRestore
    : null;
  if (field !== 'image-upload') {
    this.pendingImageRestore = null;
  }

  return true;
}

private getImageFocusIndex(element: Element): number | undefined {
  const item = element.closest('.ra-carousel-item');
  if (!item?.parentElement) {
    return undefined;
  }

  const index = Array.from(item.parentElement.children).indexOf(item);
  return index >= 0 ? index : undefined;
}

private preserveExistingPendingTarget(
  field: 'subsection-name' | 'step-body' | 'step-notes' | 'step-answer' | 'image-upload',
  subSection: any,
  step?: any,
  imageType?: number | string,
  image?: any
): void {
  if (this.isPreservingExternalTarget) {
    return;
  }
  this.rememberPendingFocus(field, subSection, step, imageType, image);
}

private runAfterPendingImageInteraction(callback: () => void): void {
  if (this.pendingImageRestore) {
    requestAnimationFrame(() => requestAnimationFrame(callback));
    return;
  }

  callback();
}

public onSectionRightPointerDown(event: PointerEvent | MouseEvent): void {
  this.rememberPendingFocusFromTarget(event.target);
}

public onSectionRightFocusIn(event: FocusEvent): void {
  this.rememberPendingFocusFromTarget(event.target);
}

private onGlobalFocusIn = (event: FocusEvent): void => {
  this.rememberPendingFocusFromComposedPath(event);
};

private onGlobalPointerDown = (event: PointerEvent): void => {
  this.rememberPendingFocusFromComposedPath(event);
};

private onGlobalKeyDown = (event: KeyboardEvent): void => {
  if (event.key !== 'Tab') {
    return;
  }

  const current = event.target instanceof Element
    ? event.target.closest('[data-focus-field="image-upload"]') as HTMLElement | null
    : null;
  if (!current) {
    return;
  }

  const container = this.rightScrollContainer?.nativeElement as HTMLElement | undefined;
  if (!container) {
    return;
  }

  const controls = Array.from(container.querySelectorAll(
    '[data-focus-field="image-upload"]:not([tabindex="-1"])'
  )) as HTMLElement[];
  const currentIndex = controls.indexOf(current);
  const nextIndex = currentIndex + (event.shiftKey ? -1 : 1);
  const next = controls[nextIndex];
  if (next) {
    this.rememberImageFocusElement(next);
  }
};

private rememberImageFocusElement(element: Element): void {
  const subSectionKey = element.getAttribute('data-subsection-key');
  if (!subSectionKey) {
    return;
  }

  const target = {
    subSectionKey,
    stepKey: element.getAttribute('data-step-key') || undefined,
    imageType: element.getAttribute('data-image-type') || undefined,
    imageKey: element.getAttribute('data-image-key') || undefined,
    imageControl: (element.getAttribute('data-image-control') || 'name') as 'name' | 'remove' | 'upload',
    imageIndex: this.getImageFocusIndex(element),
  };
  this.pendingImageRestore = target;
  this.latestImageFocusTarget = target;
}

private rememberPendingFocusFromComposedPath(event: Event): void {
  const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
  const target = path.find((item) => item instanceof Element &&
    item.closest?.('[data-focus-field="image-upload"]')) as Element | undefined;
  if (target) {
    this.rememberPendingFocusFromTarget(target);
  }
}

public trackSubSectionNameFocus(subSection: any, event?: FocusEvent): void {
  const key = this.getSubSectionKey(subSection);
  this.subSectionNameOnFocus.set(key, String(subSection?.subSectionName || ''));
  this.rememberPendingFocus('subsection-name', subSection);
}

public onSubSectionNameBlur(subSection: any, selectedSection: any, event?: FocusEvent): void {
  const key = this.getSubSectionKey(subSection);
  const previousValue = this.subSectionNameOnFocus.get(key);
  subSection.subSectionName = String(subSection?.subSectionName || '').trim();
  const currentValue = subSection.subSectionName;
  this.subSectionNameOnFocus.delete(key);
  if (!this.rememberPendingFocusFromTarget(event?.relatedTarget || null)) {
    this.preserveExistingPendingTarget('subsection-name', subSection);
  }
  this.isPreservingExternalTarget = false;

  if (previousValue !== undefined && previousValue === currentValue) {
    return;
  }

  this.runAfterPendingImageInteraction(() => {
    this.fnSubSectionNameChanges(null, subSection, selectedSection);
  });
  if (this.hasDuplicateName('subsection', currentValue, subSection)) {
    subSection.subSectionName = previousValue ?? subSection.subSectionName;
    this.showDuplicateNameToast('subsection');
    this.changeDetectorRef.detectChanges();
    return;
  }

  this.fnSubSectionNameChanges(null, subSection, selectedSection);
}

public trackStepBodyFocus(step: any, subSection: any, event?: CustomEvent): void {
  const key = this.getStepKey(step);
  this.stepBodyOnFocus.set(key, String(step?.stepBody || ''));
  this.rememberPendingFocus('step-body', subSection, step);
}

public onStepBodyBlur(step: any, subSection: any, selectedSection: any, event?: CustomEvent): void {
  const key = this.getStepKey(step);
  const previousValue = this.stepBodyOnFocus.get(key);
  step.stepBody = String(step?.stepBody || '').trim();
  const currentValue = step.stepBody;
  this.stepBodyOnFocus.delete(key);
  if (!this.rememberPendingFocusFromTarget((event as any)?.relatedTarget || null)) {
    this.preserveExistingPendingTarget('step-body', subSection, step);
  }
  this.isPreservingExternalTarget = false;

  if (previousValue !== undefined && previousValue === currentValue) {
    return;
  }

  if (this.isDuplicateStepName(currentValue, subSection, step)) {
    step.stepBody = previousValue ?? step.stepBody;
    this.showDuplicateNameToast('step');
    this.changeDetectorRef.detectChanges();
    return;
  }

  this.fnStepBodyChanges(step, subSection, selectedSection);
  this.runAfterPendingImageInteraction(() => {
    this.fnStepBodyChanges(step, subSection, selectedSection);
  });
}

public trackStepNotesFocus(step: any, subSection: any, event?: CustomEvent): void {
  const key = this.getStepKey(step);
  this.stepNotesOnFocus.set(key, String(step?.stepNotes || ''));
  this.rememberPendingFocus('step-notes', subSection, step);
}

public onNoteBlur(ev: any, step: any, subsection: any, section: any): void {
  const key = this.getStepKey(step);
  const previousValue = this.stepNotesOnFocus.get(key);
  const currentValue = String(step?.stepNotes || '');
  this.stepNotesOnFocus.delete(key);
  if (!this.rememberPendingFocusFromTarget(ev?.relatedTarget || null)) {
    this.preserveExistingPendingTarget('step-notes', subsection, step);
  }
  this.isPreservingExternalTarget = false;

  if (previousValue !== undefined && previousValue === currentValue) {
    return;
  }

  this.runAfterPendingImageInteraction(() => {
    this.onNoteChange(ev, step, subsection, section);
  });
}

fnStepBodyChanges(step,subSection,selectedSection, isDeleteImage?, imageId?) {
  this.onSave(step,subSection,selectedSection, isDeleteImage, imageId);
}

// Writing Tools entry points for the Question/Notes fields.
onProofread(step: any, subSection: any, field: 'stepBody' | 'stepNotes'): void {
  // Going through the always-visible toolbar instead of the selection
  // bubble's own buttons never told the selection bubble it's done — it has
  // no idea a different entry point just ran the same action, so it was
  // left showing, stale, pointed at a selection nobody's acting on anymore.
  this.selectionToolbar = null;
  this.lastSelection = null;
  this.runWritingTool(step, subSection, field, 'proofread');
}

onRewrite(step: any, subSection: any, field: 'stepBody' | 'stepNotes'): void {
  this.selectionToolbar = null;
  this.lastSelection = null;
  this.runWritingTool(step, subSection, field, 'rewrite');
}

onToggleAdjust(step: any, subSection: any, field: 'stepBody' | 'stepNotes'): void {
  if (this.isAdjustOpen(step, field)) {
    this.closeAdjust();
  } else {
    this.openAdjust(step, subSection, field);
  }
}

openAdjust(step: any, subSection: any, field: 'stepBody' | 'stepNotes'): void {
  this.selectionToolbar = null;
  this.lastSelection = null;
  this.activeAdjust = {
    step,
    subSection,
    field,
    error: '',
    applied: false,
    appliedSkillId: '',
  };
  // The bar focuses its own box once Angular has rendered it.
  setTimeout(() => this.adjustBars?.first?.focusInput(0), 60);
}

closeAdjust(): void {
  this.activeAdjust = null;
}

isAdjustOpen(step: any, field: 'stepBody' | 'stepNotes'): boolean {
  return this.activeAdjust?.step === step && this.activeAdjust?.field === field;
}

isAdjustLoading(step: any, field: 'stepBody' | 'stepNotes'): boolean {
  const prefix = field === 'stepBody' ? 'q' : 'n';
  return !!step[prefix + 'AdjustLoading'];
}

/** The bar owns the box, the slash menu and the saved styles; this component
 *  owns the model call and the step it writes back to. */
onAdjustApply(step: any, subSection: any, field: 'stepBody' | 'stepNotes',
              e: { instruction: string; skillId: string }): void {
  if (!this.activeAdjust || this.isAdjustLoading(step, field)) return;
  this.activeAdjust.applied = false;
  this.activeAdjust.appliedSkillId = e.skillId;
  this.activeAdjust.error = '';
  this.runWritingTool(step, subSection, field, 'adjust', e.instruction);
}

/** A style was saved or deleted, so the previous run's tab no longer applies. */
clearAdjustResult(): void {
  if (!this.activeAdjust) return;
  this.activeAdjust.applied = false;
  this.activeAdjust.appliedSkillId = '';
}

// ——— AI writing undo / redo / version history ———
// History is keyed off the same stable identifiers as focus restoration, so it
// survives the roadmap's re-fetch/re-render after every save (which replaces
// the step objects). Session-only — see AiWritingHistoryService.
private fieldKey(step: any, subSection: any, field: 'stepBody' | 'stepNotes'): string {
  return `${this.getSubSectionKey(subSection)}::${this.getStepKey(step)}::${field}`;
}

hasAiHistory(step: any, subSection: any, field: 'stepBody' | 'stepNotes'): boolean {
  return this.aiHistory.hasHistory(this.fieldKey(step, subSection, field));
}

canUndoAi(step: any, subSection: any, field: 'stepBody' | 'stepNotes'): boolean {
  return this.aiHistory.canUndo(this.fieldKey(step, subSection, field));
}

canRedoAi(step: any, subSection: any, field: 'stepBody' | 'stepNotes'): boolean {
  return this.aiHistory.canRedo(this.fieldKey(step, subSection, field));
}

onUndoAi(step: any, subSection: any, field: 'stepBody' | 'stepNotes'): void {
  this.applyHistoryEntry(step, subSection, field, (key) => this.aiHistory.undo(key));
}

onRedoAi(step: any, subSection: any, field: 'stepBody' | 'stepNotes'): void {
  this.applyHistoryEntry(step, subSection, field, (key) => this.aiHistory.redo(key));
}

// Shared write-back for undo/redo/restore: fold in any manual edits first (so
// they're preserved as the current entry, never a new undo step), move the
// pointer, then apply exactly like an AI op — same reveal sweep, same server
// save, since writing straight onto the step bypasses the blur autosave.
private applyHistoryEntry(
  step: any,
  subSection: any,
  field: 'stepBody' | 'stepNotes',
  mutate: (key: string) => HistoryEntry | null,
): void {
  if (this.isReadonlyRoadmap || this.fromLibrary) return;
  if (this.isFieldBusy(step, field)) return;
  const key = this.fieldKey(step, subSection, field);
  this.aiHistory.syncCurrent(key, step[field] || '');
  const entry = mutate(key);
  if (!entry) return;
  step[field] = entry.text;
  this.startReveal(step, field);
  this.onSave(step, subSection, this.selectedSection);
}

async openAiHistory(step: any, subSection: any, field: 'stepBody' | 'stepNotes'): Promise<void> {
  if (this.isReadonlyRoadmap || this.fromLibrary) return;
  const key = this.fieldKey(step, subSection, field);
  // Reflect any unsaved manual edits in the compare view before it opens.
  this.aiHistory.syncCurrent(key, step[field] || '');
  const history = this.aiHistory.get(key);
  if (!history || history.entries.length <= 1) return;
  const modal = await this.modalController.create({
    component: AiHistoryModalComponent,
    cssClass: 'ai-history-modal',
    componentProps: {
      entries: history.entries,
      index: history.index,
      fieldLabel: this.translate.instant(field === 'stepBody' ? 'Question' : 'Notes'),
    },
  });
  await modal.present();
  const result = await modal.onDidDismiss();
  const restoreIndex = result?.data?.restoreIndex;
  if (typeof restoreIndex === 'number') {
    this.applyHistoryEntry(step, subSection, field, (k) => this.aiHistory.restoreTo(k, restoreIndex));
  }
}

// stepBody carries the compliance-question context (kept as a checkable
// question, never turned into a statement or a new requirement); stepNotes
// is free-text observation tied to the same checklist item.
private fieldContextFor(field: 'stepBody' | 'stepNotes'): { type: 'roadmap-question' | 'roadmap-notes' } {
  return { type: field === 'stepBody' ? 'roadmap-question' : 'roadmap-notes' };
}

// ——— "AI is working on this field" indicator ———
// A rotating status line (Claude Code CLI's spinner-text mechanic, tuned to
// this app's calm/precise register rather than CLI whimsy) shown inside the
// field while a request is in flight, plus a rotating gradient ring on the
// field's own border (see .ai-field-loading in the stylesheet) — SCOPED to
// just that one field's box, not a page-wide overlay. One shared timer
// drives the phrase for whichever field(s) are busy; isFieldBusy() below is
// what the template actually keys off of.
private static readonly AI_LOADING_PHRASES = [
  'Reading it twice…',
  'Sharpening the wording…',
  'Untangling that sentence…',
  "Dotting the i's…",
  'Trimming the fluff…',
  'Choosing stronger words…',
  "Crossing the t's…",
  'Consulting the style guide…',
];
aiLoadingPhrase = RoadmapViewCreateComponent.AI_LOADING_PHRASES[0];
private aiPhraseTimer: any = null;
private aiBusyCount = 0;

// Generate is drafting NEW text from a description, not editing text that's
// already there — "Dotting the i's…" reads as a proofreading joke sitting
// on top of a blank field, which is exactly backwards. Separate phrase
// pool + its own timer, shown inside the bubble itself (see
// .ai-generate-status) rather than the field's veil, since while composing
// the field is still empty — there's nothing there to hide.
private static readonly AI_COMPOSING_PHRASES = [
  'Turning that into words…',
  'Shaping your idea…',
  'Drafting it now…',
  'Finding the right phrasing…',
  'Putting it into sentences…',
  'Composing a draft…',
];
aiComposingPhrase = RoadmapViewCreateComponent.AI_COMPOSING_PHRASES[0];
private aiComposingPhraseTimer: any = null;

// ngFor + trackBy-on-the-string forces the phrase <span> to be re-created
// each swap, so its CSS entrance (blur-morph in) re-runs every time.
trackByPhrase(index: number, phrase: string): string {
  return phrase;
}

private beginAiBusy(): void {
  this.aiBusyCount++;
  if (this.aiBusyCount === 1) {
    let i = 0;
    // The array itself holds the English strings as translation KEYS (static
    // fields can't reach an injected TranslateService); the actual value
    // shown is resolved through it on every swap.
    this.aiLoadingPhrase = this.translate.instant(RoadmapViewCreateComponent.AI_LOADING_PHRASES[0]);
    this.aiPhraseTimer = setInterval(() => {
      i = (i + 1) % RoadmapViewCreateComponent.AI_LOADING_PHRASES.length;
      this.aiLoadingPhrase = this.translate.instant(RoadmapViewCreateComponent.AI_LOADING_PHRASES[i]);
    }, 1600);
  }
}

// Runs the left→right blur-morph reveal sweep (see .ai-field-revealing) on
// the REAL textarea itself, not a separate clone layer. An earlier version
// swapped a positioned clone <div> in for the reveal, but its padding/
// line-height could never quite match ion-textarea's own shadow-internal
// box, so the text visibly jumped when the clone was swapped back out for
// the real field. Masking/blurring the real element (CSS filter/mask apply
// to a custom element's whole composed paint, shadow DOM included, same as
// they would to an <img>) means there's nothing to swap — zero jump.
private startReveal(step: any, field: 'stepBody' | 'stepNotes'): void {
  const revealKey = (field === 'stepBody' ? 'q' : 'n') + 'Revealing';
  step[revealKey] = true;
  // Must match .ai-field-revealing's animation-duration (1.35s) — this flag
  // is what keeps isFieldBusy() true, so the border beam stays lit for the
  // full sweep instead of fading out from under it early.
  setTimeout(() => {
    step[revealKey] = false;
  }, 1350);
}

private endAiBusy(): void {
  this.aiBusyCount = Math.max(0, this.aiBusyCount - 1);
  if (this.aiBusyCount === 0 && this.aiPhraseTimer) {
    clearInterval(this.aiPhraseTimer);
    this.aiPhraseTimer = null;
  }
}

isFieldBusy(step: any, field: 'stepBody' | 'stepNotes'): boolean {
  const prefix = field === 'stepBody' ? 'q' : 'n';
  const generating = this.generateBubbleAnchor?.step === step
    && this.generateBubbleAnchor?.field === field
    && !!this.generateBubble?.loading;
  // Revealing keeps the beam up through the reveal sweep, so the whole
  // sequence reads as one continuous moment instead of two states.
  return !!(step[prefix + 'ProofreadLoading'] || step[prefix + 'RewriteLoading'] || step[prefix + 'AdjustLoading'] || step[prefix + 'Revealing'] || generating);
}

// Gates the field's veil specifically — proofread/rewrite only. Generate
// deliberately excluded: its own "composing" status lives in the bubble
// (see .ai-generate-status), not on the empty field underneath it. The
// border beam still runs for all three (isFieldBusy above), so the field
// stays lit as an ambient "something's coming" cue either way.
isFieldEditing(step: any, field: 'stepBody' | 'stepNotes'): boolean {
  const prefix = field === 'stepBody' ? 'q' : 'n';
  return !!(step[prefix + 'ProofreadLoading'] || step[prefix + 'RewriteLoading'] || step[prefix + 'AdjustLoading'] || step[prefix + 'Revealing']);
}

private runWritingTool(step: any, subSection: any, field: 'stepBody' | 'stepNotes', tool: 'proofread' | 'rewrite' | 'adjust', instruction?: string): void {
  // Fast client-side fail; the routes themselves re-verify the token server-side.
  if (!this.userAuthService.checkUserExistingSync()) {
    this.toastService.presentToast(this.translate.instant('Please sign in to Blueprint to use AI writing tools.'), 2500, AppConstants.WARNING_SNACKBAR, 'top');
    return;
  }
  const loadingKey = (field === 'stepBody' ? 'q' : 'n') + (tool === 'proofread' ? 'ProofreadLoading' : tool === 'rewrite' ? 'RewriteLoading' : 'AdjustLoading');
  if (step[loadingKey]) return;
  const original = (step[field] || '').trim();
  if (!original) return;
  // Seed the field's text as the 'original' history entry before the first AI
  // op runs on it (no-op afterwards), so undo can always get back to what the
  // user had before AI touched it.
  const historyKey = this.fieldKey(step, subSection, field);
  this.aiHistory.ensureSeed(historyKey, step[field] || '');
  step[loadingKey] = true;
  this.beginAiBusy();
  this.aiWritingService.transform(tool, original, this.fieldContextFor(field), instruction)
    .then((result: string) => {
      step[field] = result;
      this.aiHistory.record(historyKey, { text: result, action: tool, at: Date.now() });
      this.startReveal(step, field);
      this.closeAdjust();
      // Every other way of editing this field (typing + blur) autosaves through
      // onSave — proofread/rewrite bypassed it entirely by writing the result
      // directly onto the step, so the change never reached the server.
      this.onSave(step, subSection, this.selectedSection);
    })
    .catch((err: any) => {
      const message = err?.error?.error ||
        this.translate.instant(tool === 'proofread' ? 'Proofread failed. Please try again.' : tool === 'rewrite' ? 'Rewrite failed. Please try again.' : 'Adjust failed. Please try again.');
      if (this.activeAdjust && this.activeAdjust.step === step && this.activeAdjust.field === field) {
        this.activeAdjust.error = message;
      }
      this.toastService.presentToast(message, 2500, AppConstants.WARNING_SNACKBAR, 'top');
    })
    .finally(() => {
      step[loadingKey] = false;
      this.endAiBusy();
    });
}

// ——— Generate-on-focus bubble ———
// Went through two earlier shapes: (1) focusing an empty field popped the
// full prompt bar immediately — distracting, interrupted a long audit on
// every empty field; (2) a small always-visible spark icon you had to
// click — safe, but needed hover to be understood, more UI than necessary.
//
// Landed on Notion's actual pattern: press Space on an empty field to open
// the prompt bar; the field's OWN placeholder announces this the instant
// it's focused ("Press space to describe what you want…" — see
// isGenerateAvailable(), bound to [placeholder] in the template), so the
// trigger is genuinely visible without a hover, but nothing appears or
// moves until you deliberately press the one key that does something
// different here. Typing any other character behaves completely normally.
generateBubble: { top: number; left: number; prompt: string; loading: boolean } | null = null;
private generateBubbleAnchor: { nativeEl: HTMLTextAreaElement; step: any; subSection: any; field: 'stepBody' | 'stepNotes' } | null = null;

async onFieldFocusForGenerate(textareaRef: any, step: any, subSection: any, field: 'stepBody' | 'stepNotes'): Promise<void> {
  if (!this.aiFeaturesEnabled) return;
  const hasText = field === 'stepBody' ? !!step.stepBody?.trim() : !!step.stepNotes?.trim();
  if (hasText) {
    // Typed past it — the field itself has taken over, same as ignoring
    // the hint outright. Nothing was ever forced.
    if (this.generateBubbleAnchor?.step === step && this.generateBubbleAnchor?.field === field) {
      this.generateBubble = null;
      this.generateBubbleAnchor = null;
    }
    return;
  }
  // Marks this field as a candidate — drives the placeholder swap via
  // isGenerateAvailable(). Space is what actually opens the bubble (see
  // onFieldSpaceForGenerate below), not focus itself.
  const nativeEl: HTMLTextAreaElement = await textareaRef.getInputElement();
  this.generateBubbleAnchor = { nativeEl, step, subSection, field };
}

// Gates the placeholder-text swap in the template — true for exactly the
// one empty, focused field, and only while the full bubble hasn't been
// opened yet (once it's open, the hint's job is done).
isGenerateAvailable(step: any, field: 'stepBody' | 'stepNotes'): boolean {
  return this.aiFeaturesEnabled
    && !this.generateBubble
    && this.generateBubbleAnchor?.step === step
    && this.generateBubbleAnchor?.field === field;
}

// The actual trigger: Space, and only when the field is still genuinely
// empty (so it never hijacks a normal space between words once you've
// started typing). Re-resolves the native element itself rather than
// trusting generateBubbleAnchor to already be set — onFieldFocusForGenerate
// is async, so a very fast Space-right-after-focus could otherwise race it.
async onFieldSpaceForGenerate(event: KeyboardEvent, textareaRef: any, step: any, subSection: any, field: 'stepBody' | 'stepNotes'): Promise<void> {
  if (!this.aiFeaturesEnabled) return;
  if (event.key !== ' ') return;
  const hasText = field === 'stepBody' ? !!step.stepBody?.trim() : !!step.stepNotes?.trim();
  if (hasText) return;
  event.preventDefault();
  const nativeEl: HTMLTextAreaElement = await textareaRef.getInputElement();
  this.generateBubbleAnchor = { nativeEl, step, subSection, field };
  this.openGenerateBubble();
}

// Opens the prompt bar for whatever field is currently the candidate, and
// carries focus straight into it — Space was a deliberate "start typing
// your description" gesture, so landing the caret there beats leaving it
// behind on the field the user just left. Needs a tick: the bubble's own
// textarea isn't in the DOM yet, it only exists once this change-detection
// cycle actually renders the *ngIf.
openGenerateBubble(): void {
  if (!this.generateBubbleAnchor) return;
  this.positionGenerateBubble();
  setTimeout(() => {
    const input = document.querySelector('.ai-generate-input') as HTMLTextAreaElement | null;
    input?.focus();
  }, 0);
}

private async positionGenerateBubble(): Promise<void> {
  if (!this.generateBubbleAnchor) return;
  let { nativeEl } = this.generateBubbleAnchor;
  if (!document.body.contains(nativeEl)) {
    // The field this bubble is anchored to can legitimately get torn down
    // and rebuilt out from under it — any autosave (even on a completely
    // different step) re-fetches the whole roadmap and re-renders the
    // accordion. Try to re-find the SAME field by its stable step/subsection
    // key (the same lookup restorePendingFocus() uses to survive this exact
    // situation for normal typing) before giving up — otherwise whatever the
    // user was typing into the bubble gets silently thrown away.
    const container = this.rightScrollContainer?.nativeElement as HTMLElement | undefined;
    const resolvedHost = container ? this.findTargetElement(container, {
      field: this.generateBubbleAnchor.field === 'stepBody' ? 'step-body' : 'step-notes',
      subSectionKey: this.getSubSectionKey(this.generateBubbleAnchor.subSection),
      stepKey: this.getStepKey(this.generateBubbleAnchor.step),
    }) as any : null;
    const resolvedNativeEl: HTMLTextAreaElement | null = resolvedHost && typeof resolvedHost.getInputElement === 'function'
      ? await resolvedHost.getInputElement()
      : null;
    if (resolvedNativeEl && this.generateBubbleAnchor) {
      this.generateBubbleAnchor.nativeEl = resolvedNativeEl;
      nativeEl = resolvedNativeEl;
    } else {
      this.generateBubble = null;
      this.generateBubbleAnchor = null;
      return;
    }
  }
  // getBoundingClientRect() on the textarea gives the border box, not
  // where the caret actually sits (misses the field's own internal
  // padding) — reuse the same mirror-div measurement the selection bubble
  // uses (start=end=0 on an empty value gives exactly the caret position)
  // instead of approximating.
  const rect = this.getSelectionRect(nativeEl, 0, 0);
  // Spawns below the cursor's whole line, not just a few px under the
  // field's top edge — offsetting by a small constant left it overlapping
  // the same row as the caret instead of clearing it. Read the textarea's
  // actual line-height so this adapts if the font ever changes, rather
  // than hard-coding a guess at the row height.
  const computedLineHeight = parseFloat(window.getComputedStyle(nativeEl).lineHeight);
  const lineHeight = Number.isFinite(computedLineHeight) ? computedLineHeight : 18;
  const gapBelowCursor = 10;
  const topOffset = lineHeight + gapBelowCursor;
  // Spawns below the cursor (the empty field's caret row) rather than
  // above it — the earlier above-cursor placement was what kept colliding
  // with the page's own header chrome near the top of the panel; below
  // never fights that space at all.
  const bubbleClearance = topOffset + 90; // room for the offset plus a couple of wrapped lines
  const scrollContainer = nativeEl.closest('.subsection-block') as HTMLElement | null;
  if (scrollContainer) {
    const containerRect = scrollContainer.getBoundingClientRect();
    if (rect.top < containerRect.top || rect.top + bubbleClearance > containerRect.bottom) {
      this.generateBubble = null;
      return;
    }
  }
  const bubbleWidth = 290; // keep in sync with .ai-generate-bubble's width in the stylesheet
  // The card's own left edge isn't the reference point — the pencil icon
  // sits before the input pill, so aligning the CARD to the cursor left
  // the actual "type here" pill (the part that visually reads as the
  // field) sitting well to the right of the caret. Shift left by exactly
  // the icon + gaps + padding that precede the pill in the stylesheet
  // (padding 6 + icon 13 + gap 6 = 25) so the pill itself, not the card,
  // lines up under the cursor.
  const innerPillOffset = 25;
  let left = rect.left - innerPillOffset;
  if (left + bubbleWidth > window.innerWidth - 12) left = window.innerWidth - bubbleWidth - 12;
  if (left < 12) left = 12;
  const prompt = this.generateBubble?.prompt ?? '';
  const loading = this.generateBubble?.loading ?? false;
  this.generateBubble = { top: rect.top + topOffset, left, prompt, loading };
}

// Same activeElement-after-settle check used elsewhere in this file: waits
// for the browser to actually finish moving focus before deciding whether
// to hide, rather than reacting to blur alone (which fires before the
// bubble's own input has had a chance to receive focus).
onFieldBlurForGenerate(): void {
  // Never tear down mid-request: the bubble's own textarea goes readonly
  // while loading (see the template), so focus can legitimately end up
  // nowhere for a moment — that's not the user dismissing anything.
  if (this.generateBubble?.loading) return;
  setTimeout(() => {
    const active = document.activeElement;
    const bubbleEl = document.querySelector('.ai-generate-bubble');
    const anchorEl = this.generateBubbleAnchor?.nativeEl;
    if (active && ((bubbleEl && bubbleEl.contains(active)) || active === anchorEl)) {
      return;
    }
    this.generateBubble = null;
    this.generateBubbleAnchor = null;
  }, 0);
}

private beginComposing(): void {
  let i = 0;
  this.aiComposingPhrase = this.translate.instant(RoadmapViewCreateComponent.AI_COMPOSING_PHRASES[0]);
  this.aiComposingPhraseTimer = setInterval(() => {
    i = (i + 1) % RoadmapViewCreateComponent.AI_COMPOSING_PHRASES.length;
    this.aiComposingPhrase = this.translate.instant(RoadmapViewCreateComponent.AI_COMPOSING_PHRASES[i]);
  }, 1600);
}

private endComposing(): void {
  if (this.aiComposingPhraseTimer) {
    clearInterval(this.aiComposingPhraseTimer);
    this.aiComposingPhraseTimer = null;
  }
}

onGenerateFromBubble(): void {
  if (!this.generateBubble || !this.generateBubble.prompt?.trim() || this.generateBubble.loading) return;
  if (!this.userAuthService.checkUserExistingSync()) {
    this.toastService.presentToast(this.translate.instant('Please sign in to Blueprint to use AI writing tools.'), 2500, AppConstants.WARNING_SNACKBAR, 'top');
    return;
  }
  const anchor = this.generateBubbleAnchor;
  if (!anchor) return;
  const promptText = this.generateBubble.prompt.trim();
  // The field is empty here (generate only fires on an empty field), so the
  // seeded 'original' is empty text — undo after a generate returns the field
  // to blank, redo brings the draft back.
  const historyKey = this.fieldKey(anchor.step, anchor.subSection, anchor.field);
  this.aiHistory.ensureSeed(historyKey, anchor.step[anchor.field] || '');
  this.generateBubble.loading = true;
  this.beginAiBusy();
  this.beginComposing();
  this.aiWritingService.generate(promptText, this.fieldContextFor(anchor.field))
    .then((result: string) => {
      anchor.step[anchor.field] = result;
      this.aiHistory.record(historyKey, { text: result, action: 'generate', at: Date.now(), prompt: promptText });
      this.startReveal(anchor.step, anchor.field);
      this.generateBubble = null;
      this.generateBubbleAnchor = null;
      // Same gap as proofread/rewrite: writing straight onto the step
      // never went through the blur-triggered autosave, so it silently
      // never reached the server.
      this.onSave(anchor.step, anchor.subSection, this.selectedSection);
    })
    .catch((err: any) => {
      const message = err?.error?.error || this.translate.instant('Generate failed. Please try again.');
      this.toastService.presentToast(message, 2500, AppConstants.WARNING_SNACKBAR, 'top');
      if (this.generateBubble) this.generateBubble.loading = false;
    })
    .finally(() => {
      this.endAiBusy();
      this.endComposing();
    });
}

// Standard auto-grow textarea: reset to measure the true content height,
// then set it, so the box grows downward as the prompt wraps instead of
// scrolling inside a fixed-height field.
onGenerateInput(event: Event): void {
  const el = event.target as HTMLTextAreaElement;
  el.style.height = 'auto';
  el.style.height = el.scrollHeight + 'px';
}

// ——— Selection-triggered AI menu (Notion-style: select text, get a small
// menu anchored to the selection). One shared instance for the whole page —
// only one text selection can exist in the browser at a time anyway.
// The bubble is position:fixed (needed to escape this page's
// overflow:hidden panels), so it doesn't inherit scrolling for free like a
// normal in-flow element would. lastSelection remembers which textarea/
// start/end produced the current bubble, so the scroll listener can
// recompute its position and make it track the text — new selection makes
// a fresh one and replaces this, same as before.
selectionToolbar: { step: any; subSection: any; field: 'stepBody' | 'stepNotes'; top: number; left: number } | null = null;
private selectionCheckTimer: any;
private lastSelection: { nativeEl: HTMLTextAreaElement; start: number; end: number; step: any; subSection: any; field: 'stepBody' | 'stepNotes' } | null = null;
private selectionRafId: number | null = null;

async onTextSelect(textareaRef: any, step: any, subSection: any, field: 'stepBody' | 'stepNotes'): Promise<void> {
  if (!this.aiFeaturesEnabled) return;
  clearTimeout(this.selectionCheckTimer);
  this.selectionCheckTimer = setTimeout(async () => {
    const nativeEl: HTMLTextAreaElement = await textareaRef.getInputElement();
    const start = nativeEl.selectionStart;
    const end = nativeEl.selectionEnd;
    if (start == null || end == null || end - start < 2 || !nativeEl.value.substring(start, end).trim()) {
      this.selectionToolbar = null;
      this.lastSelection = null;
      return;
    }
    this.lastSelection = { nativeEl, start, end, step, subSection, field };
    this.positionSelectionToolbar();
  }, 150);
}

private positionSelectionToolbar(): void {
  if (!this.lastSelection) return;
  const { nativeEl, start, end, step, subSection, field } = this.lastSelection;
  if (!document.body.contains(nativeEl)) {
    this.selectionToolbar = null;
    this.lastSelection = null;
    return;
  }
  const rect = this.getSelectionRect(nativeEl, start, end);
  // A fixed pixel guess for "has this scrolled behind the header" doesn't
  // hold up — the actual boundary is wherever THIS panel's own scroll
  // container (.subsection-block, overflow-y:auto) currently sits, which
  // moves with the page/viewport itself. Ask the real DOM for that
  // container's current top edge instead of assuming a constant.
  // The bubble itself renders ~45px above the text (its own height plus the
  // pointer gap) — so it needs that much clearance above the container's
  // top edge, not just the text's own top pixel, or the bubble still pokes
  // out over the boundary even while the text is technically still visible.
  const bubbleClearance = 45;
  const scrollContainer = nativeEl.closest('.subsection-block') as HTMLElement | null;
  if (scrollContainer) {
    const containerRect = scrollContainer.getBoundingClientRect();
    if (rect.top - bubbleClearance < containerRect.top || rect.top > containerRect.bottom) {
      this.selectionToolbar = null;
      return;
    }
  } else if (rect.top - bubbleClearance < 0 || rect.top > window.innerHeight) {
    this.selectionToolbar = null;
    return;
  }
  const bubbleWidth = 148;
  let left = rect.left;
  if (left + bubbleWidth > window.innerWidth - 12) {
    left = window.innerWidth - bubbleWidth - 12;
  }
  if (left < 12) left = 12;
  // Above the selection, Medium-editor style — a downward pointer anchors
  // it to the text, and it never covers the word you just selected.
  this.selectionToolbar = { step, subSection, field, top: rect.top - 10, left };
}

// The bubble only ever cleared itself when a NEW mouseup/keyup on the SAME
// textarea reported a collapsed (empty) selection — nothing tore it down
// when focus left the field entirely (clicking into a different field,
// scrolling away and clicking elsewhere on the page, etc.), so a stale
// selection could sit there and get repositioned back into view by the
// scroll handler even though it no longer means anything. Same
// activeElement-after-settle pattern as onFieldBlurForGenerate: the
// bubble's own buttons already stay clear of this (their container has
// (mousedown)="$event.preventDefault()", see the template), so a real
// blur here means the user genuinely moved on.
onFieldBlurForSelection(): void {
  setTimeout(() => {
    const active = document.activeElement;
    const bubbleEl = document.querySelector('.ai-selection-menu');
    const anchorEl = this.lastSelection?.nativeEl;
    if (active && ((bubbleEl && bubbleEl.contains(active)) || active === anchorEl)) {
      return;
    }
    this.selectionToolbar = null;
    this.lastSelection = null;
  }, 0);
}

onProofreadSelection(): void {
  if (!this.selectionToolbar) return;
  const { step, subSection, field } = this.selectionToolbar;
  this.selectionToolbar = null;
  this.lastSelection = null;
  this.runWritingTool(step, subSection, field, 'proofread');
}

onRewriteSelection(): void {
  if (!this.selectionToolbar) return;
  const { step, subSection, field } = this.selectionToolbar;
  this.selectionToolbar = null;
  this.lastSelection = null;
  this.runWritingTool(step, subSection, field, 'rewrite');
}

// Standard mirror-div technique: <textarea> has no native API for a
// selection's on-screen rect (unlike contenteditable's Range), so we clone
// the textarea's box/font metrics onto an offscreen div, mark the selected
// substring with a span, and measure that span instead.
private getSelectionRect(textarea: HTMLTextAreaElement, start: number, end: number): { top: number; bottom: number; left: number } {
  const computed = window.getComputedStyle(textarea);
  const mirror = document.createElement('div');
  const props: (keyof CSSStyleDeclaration)[] = [
    'boxSizing', 'width', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft',
    'borderTopWidth', 'borderRightWidth', 'borderBottomWidth', 'borderLeftWidth',
    'fontFamily', 'fontSize', 'fontWeight', 'lineHeight', 'letterSpacing'
  ];
  props.forEach((p) => {
    (mirror.style as any)[p] = computed[p as any];
  });
  mirror.style.position = 'absolute';
  mirror.style.visibility = 'hidden';
  mirror.style.whiteSpace = 'pre-wrap';
  mirror.style.wordWrap = 'break-word';
  mirror.style.top = '0';
  mirror.style.left = '-9999px';

  const value = textarea.value;
  mirror.appendChild(document.createTextNode(value.substring(0, start)));
  const marker = document.createElement('span');
  marker.textContent = value.substring(start, end) || '​';
  mirror.appendChild(marker);
  mirror.appendChild(document.createTextNode(value.substring(end)));
  document.body.appendChild(mirror);

  const markerRect = marker.getBoundingClientRect();
  const mirrorRect = mirror.getBoundingClientRect();
  const textareaRect = textarea.getBoundingClientRect();
  const relLeft = markerRect.left - mirrorRect.left;
  const relTop = markerRect.top - mirrorRect.top;
  const relBottom = markerRect.bottom - mirrorRect.top;

  document.body.removeChild(mirror);

  return {
    top: textareaRect.top - textarea.scrollTop + relTop,
    bottom: textareaRect.top - textarea.scrollTop + relBottom,
    left: textareaRect.left - textarea.scrollLeft + relLeft
  };
}

fnSubSectionNameChanges(step,subSection,selectedSection) {
 this.selectedSection = this.sections[this.selectedIndex];
 this.onSave(step,subSection,selectedSection);
}


onRadioSelectionChanged(event: any, step: any, subSection: any, selectedSection: any) { 
  this.rememberPendingFocus('step-answer', subSection, step);

  const selectedValue = event.detail.value;
  const selectedOption = this.complianceOptions.find(option => option.value === selectedValue)?.label;

  // Mapping of selected options to step.answer values
  const optionMapping: { [key: string]: { answer: number, class: string, value: string } } = {
    'Yes, Compliant': { answer: 1, class: 'yes-compliant', value: 'yesCompliant' },
    'Not applicable': { answer: 3, class: 'not-applicable', value: 'notApplicable' },
    'Report Hazard': { answer: 4, class: 'hazard-background', value: 'hazard' },
    'Not Compliant': { answer: 2, class: 'not-compliant', value: 'notCompliant' }
  };

  if (!selectedOption || !optionMapping[selectedOption]) {
    console.warn('Invalid selection');
    return;
  }

  const { answer, class: selectColorClass, value } = optionMapping[selectedOption];

  // ✅ Return early if `step.answer` remains unchanged
  if (Number(step.answer) === Number(answer)) 
    return;
  else
  {
  // Update step properties only when `step.answer` actually changes
  step.answer = answer;
  step.selectColorClass = selectColorClass;
  step.selectedValue = value;
  step.stepNotes = '';
  step.stepNote = '';
  step.stepNotesInvalid = false;
  step.stepNotesChange = true;
  step.media = [];
  // Enable or disable save button based on conditions
  this.isSaveDisabled = (selectedOption === 'Not Compliant' && (!step?.stepNotes || step?.stepNotes.trim() === ''));

  // Call save method
  //if(!(step.answer == 4))
  this.onSave(step, subSection, selectedSection);
   // Close all other accordions
  }
}
private notifyHazardDetailsChange(): void {
  this.sharedValue.showHazardDetailsState$.next(this.showHazardDetails);
}
showHazardDetails: boolean;
stepId: string;
hazardId: string;
addHazardDetails(index, step,subSection,section) 
{
  if (step.stepBody) {
    this.rememberHazardReturnState(step);
    this.hazardInfo = null;
    this.hazardId = '';
    this.version = '1';
    this.stepId = step.stepId; 
    this.showHazardDetails=true;
    this.notifyHazardDetailsChange();
    this.eventProvider.BroadcastEvent('edit-hazard', false);
    
  } else {
    this.toastService.presentToast('Please complete all the mandatory Fields', 4000, AppConstants.ERROR_SNACKBAR, 'top');
  }

}

getAllHazardsForCopyByRoadmapId(roadmapId) {
  this.backendService.getAllHazardsForCopyByRoadmapId(roadmapId).then((data: any) => {
    if (data) {
     this.copiedHazard = data.response;
  }
  }).catch((error: any) => {
    console.error('Error fetching hazard details:', error);
  });  
}

private updateHazardOverlayClass(show: boolean) {
  if (show) {
    document.body.classList.add('hazard-overlay-active');
  } else {
    document.body.classList.remove('hazard-overlay-active');
  }
}
/**
 * Copies hazard
 * 
 * @param index 
 * @param step 
 * @param subSection 
 * @param selectedSection 
 */
public async copyHazard(index, step, subSection, selectedSection) {
 this.backendService.getAllHazardsForCopyByRoadmapId(this.roadmapId).then(async (data: any) => {
    if (data) {
    const props = { roadmapSections: data.response, roadmapId: this.roadmapId, stepId: step.stepId };
    const modal = await this.modalController.create({
      component: CopyRoadmapComponent,
      cssClass: 'medium-alert-modal',
      backdropDismiss: false,
      showBackdrop: false,
      componentProps: props
    });
    await modal.present();
    await  modal.onDidDismiss().then((result: any) => {
      if (result.data.dataType != undefined && result.data.dataType === AppConstants.ADD_HAZARD) {
        this.updateHazardOverlayClass(false);
        this.addHazardDetails(index, step, subSection, selectedSection)
      } else if (result.data.dataType != undefined && result.data.dataType === AppConstants.COPY_HAZARD) {
        this.copiedHazard = result.data.copiedHazard;
        this.updateHazardOverlayClass(false);
        this.backendService.copyHazardToStep(this.copiedHazard).then((data: any) => {
          if (data.statusCode == 200) {
              this.toastService.presentToast('Hazards Copied Successfully', 4000, AppConstants.SUCCESS_SNACKBAR, 'top');               
              this.fnViewRoadmap(null);
            } else {
              this.toastService.presentToast('Failed to Copy Hazards', 4000, AppConstants.ERROR_SNACKBAR, 'top');
            }          
          },
          err => {
            this.toastService.presentToast(err.message, 4000, AppConstants.ERROR_SNACKBAR, 'top', 'error_occurred');
          }
        ); 
      }
    });
    
    }
   });  
  }

  /**
   * Closes roadmap view create component
   */
  public close(){
      this.modalController.dismiss();
  }

  /**
   * To enable save button on changing note text
   * @param ev 
   * @param step 
   */
  public onNoteChange(ev, step, subsection, section) {    
    const value = step.stepNotes;
    if (value && value.trim() === '') {
      step.stepNotesInvalid = true;
      return;
    }
    step.stepNotesInvalid = false;
    step.stepNote = value; 
    step.stepNotesChange = true;
    this.onSave(step,subsection,section);   
  }

  public onPadlockChange(boolean, step, subsection, section) {    
    step.padLock=boolean;
    this.onSave(step,subsection,section);   
  }

setRadioButtonSelection(element) {
  if (element.yesComplaint) {
    element.selectedValue = 'yesCompliant';
    element.selectColorClass = 'yes-compliant';
  } else if (element.notApplicable) {
    element.selectedValue = 'notApplicable';
    element.selectColorClass = 'not-applicable';
  } else if (element.hazard) {
    element.selectedValue = 'hazard';
    element.selectColorClass = 'hazard-background'
  } else if (element.notCompliant) {
    element.selectedValue = 'notCompliant';
    element.selectColorClass = 'not-compliant';
  } else {
    element.selectedValue = '';
    element.selectColorClass = ''
  } 

}


hazardInfo : any;
getHazardDetails(hazard,step){
  this.rememberHazardReturnState(step);
  this.backendService.getHazardDetails(hazard.id).then((data: any) => {
    if (data) {
      console.log('Hazard details:', data);
      this.stepId = step.stepId;
      this.hazardId = hazard.id;
      this.version = hazard.version;
      // Normalize the response to handle null values
      this.hazardInfo = this.normalizeHazardResponse(data.response);
      this.isReadonlyHazard = this.isReadonlyRoadmap;
      this.showHazardDetails=true;
      this.notifyHazardDetailsChange();
      this.updateHazardOverlayClass(this.isReadonlyHazard);
    }
  }).catch((error: any) => {
    console.error('Error fetching hazard details:', error);
  });
}

/**
 * Normalizes hazard response from backend to handle null values
 * Converts null objects to expected empty structures for Angular template bindings
 * Also syncs machine modes from initialHazards to hazardRatingnumber if needed
 */
private normalizeHazardResponse(response: any): any {
  if (!response) return null;

  // Get machine modes from initialHazards if hazardRatingnumber.machineModes is empty
  const initialHazardsModes = response.initialHazards?.machineModes || [];
  const hazardRatingModes = response.hazardRatingnumber?.machineModes || [];
  
  // Use hazardRatingnumber.machineModes if available, otherwise fallback to initialHazards.machineModes
  const finalMachineModes = hazardRatingModes.length > 0 ? hazardRatingModes : initialHazardsModes;

  // Normalize hazardType sources and consequences to ensure consistent structure
  const hazardType = response.hazardType || {
    id: '',
    hazardTypeName: '',
    hazardSources: [],
    hazardConsequences: []
  };

  hazardType.id = hazardType.id || hazardType.hazardTypeId || '';
  hazardType.id = hazardType.id === null || hazardType.id === undefined ? '' : String(hazardType.id);

  // Ensure sources have 'value' property (normalize from 'Value' if needed)
  if (hazardType.hazardSources) {
    hazardType.hazardSources = hazardType.hazardSources.map(source => ({
      id: source.id || source.Id || source.hazardSourceId || '',
      value: source.value || source.Value || ''
    })).map(source => ({
      ...source,
      id: source.id === null || source.id === undefined ? '' : String(source.id)
    }));
  }

  // Ensure consequences have 'value' property (normalize from 'Value' if needed)
  if (hazardType.hazardConsequences) {
    hazardType.hazardConsequences = hazardType.hazardConsequences.map(consequence => ({
      id: consequence.id || consequence.Id || consequence.hazardConsequenceId || '',
      value: consequence.value || consequence.Value || ''
    })).map(consequence => ({
      ...consequence,
      id: consequence.id === null || consequence.id === undefined ? '' : String(consequence.id)
    }));
  }

  return {
    ...response,
    hazardName: response.hazardName || '',
    hazardType: hazardType,
    hazardRatingnumber: {
      machineModes: finalMachineModes.map(mode => ({
        id: mode.id || mode.Id || '',
        value: mode.value || mode.Value || ''
      })),
      hazardRating: response.hazardRatingnumber?.hazardRating || []
    },
    initialHazards: {
      initial_hazard: response.initialHazards?.initial_hazard || '',
      machineModes: initialHazardsModes.map(mode => ({
        id: mode.id || mode.Id || '',
        value: mode.value || mode.Value || ''
      }))
    },
    controlMeasure: response.controlMeasure || '',
    controlMeasures: response.controlMeasures || [],
    hazardMedia: response.hazardMedia || [],
    plrObj: response.plrObj || {
      category: '',
      plr: '',
      sValue: '',
      fValue: '',
      pValue: ''
    }
  };
}

/**
 * Checks if step has any pending (non-completed) hazards
 * @param step - The step to check
 * @returns true if there are pending hazards
 */
hasPendingHazards(step: any): boolean {
  if (!step?.hazard || step.hazard.length === 0) {
    return false;
  }
  return step.hazard.some(h => h.completionStatus !== 'Completed');
}

/**
 * Checks if subsection has any steps with missing completion status
 * A step is pending if:
 * 1. The answer is 0 or not set (no compliance option selected), OR
 * 2. The answer is 4 (Report Hazard) and there are pending (non-completed) hazards
 * @param subSection - The subsection to check
 * @returns true if there are pending steps
 */
hasSubsectionPendingSteps(subSection: any): boolean {
  if (!subSection?.steps || subSection.steps.length === 0) {
    return false;
  }
  return subSection.steps.some(step => {
    // Step has no answer selected (0 or undefined/null)
    if (!step.answer || step.answer === 0) {
      return true;
    }
    // Step has "Report Hazard" (4) selected but has pending hazards
    if (step.answer === 4 && this.hasPendingHazards(step)) {
      return true;
    }
    return false;
  });
}

fnGetOptionDetails(value: number): { optionName: string; selectColorClass: string } {
  const optionMapping: { [key: number]: { optionName: string; selectColorClass: string } } = {
    1: { optionName: this.translate.instant("Yes, Compliant"), selectColorClass: "yes-compliant" },
    2: { optionName: this.translate.instant("Not Compliant"), selectColorClass: "not-compliant" },
    3: { optionName: this.translate.instant("Not applicable"), selectColorClass: "not-applicable" },
    4: { optionName: this.translate.instant("Report Hazard"), selectColorClass: "hazard-background" },
  };

  if (value === 4) {
    return { optionName: this.translate.instant("Hazard Reported"), selectColorClass: optionMapping[value]?.selectColorClass || "" };
  }

  return optionMapping[value] || { optionName: "", selectColorClass: "" };
}

/**
 * Toggles accordion
 * 
 * @param step 
 * @param stepIndex 
 */
public toggleAccordion(step, stepIndex) {  
  this.replaceArrayContents(this.previewCompliantImages);
  this.replaceArrayContents(this.previewNotCompliantImages);
  if(step?.media?.length) {
    this.syncStepMediaOrderAndNames(step);
    
    switch(step.answer) {
      case 1: // Compliant
        this.replaceArrayContents(this.previewCompliantImages, this.getOrderedStepMedia(step, true));
        break;
      case 2: // Not Compliant
        this.replaceArrayContents(this.previewNotCompliantImages, this.getOrderedStepMedia(step, false));
        break;
    }
  }

  // Track if any accordion will be open after this toggle
  let willBeOpen = false;
  let openSubSection = null;

  this.subSections.forEach((subSection) => {
    // Check if the current subsection contains the clicked step
    if (subSection.steps.includes(step)) {
      // Loop through all steps in the current subsection
      subSection.steps.forEach((stp, i) => {
        // Toggle the clicked accordion and close all others
        const isOpen = i === stepIndex ? !stp.accordionOpen : false;
        stp.accordionOpen = isOpen;
        if (isOpen) {
          willBeOpen = true;
          openSubSection = subSection;
        }
      });
    } else {
      // Handle subsections that don't contain the clicked step
      subSection.steps.forEach((stp) => {
        // Close all steps in non-matching subsections
        stp.accordionOpen = false;
      });
    }
  });

  // Update breadcrumb based on accordion state
  if (willBeOpen && openSubSection) {
    this.currentBreadcrumb = {
      sectionName: this.selectedSection?.sectionName || '',
      subSectionName: openSubSection?.subSectionName || '',
      stepName: step?.stepBody || '',
      isVisible: true
    };
  } else {
    this.currentBreadcrumb.isVisible = false;
  }
}
/**
   * Refreshes previewCompliantImages / previewNotCompliantImages directly from
   * the raw backend sectionDetails payload, bypassing any locally-preserved media.
   * Called after every roadmapExecution response in onSave so that multi-batch
   * uploads never leave stale IDs in the preview arrays.
   */
  private refreshPreviewArraysFromResponse(sectionDetails: any[], step: any): void {
    if (!step?.stepId || !Array.isArray(sectionDetails)) return;

    // Only refresh if the step's accordion is currently open.
    const isStepOpen = (this.subSections || []).some((ss: any) =>
      (ss.steps || []).some((s: any) => s.stepId === step.stepId && s.accordionOpen)
    );
    if (!isStepOpen) return;

    for (const subSection of sectionDetails) {
      const backendStep = (subSection?.steps || []).find((s: any) => s.stepId === step.stepId);
      if (!backendStep) continue;

      this.replaceArrayContents(this.previewCompliantImages);
      this.replaceArrayContents(this.previewNotCompliantImages);

      if (backendStep?.media?.length) {
        this.syncStepMediaOrderAndNames(backendStep);
        switch (backendStep.answer) {
          case 1:
            this.replaceArrayContents(this.previewCompliantImages, this.getOrderedStepMedia(backendStep, true));
            break;
          case 2:
            this.replaceArrayContents(this.previewNotCompliantImages, this.getOrderedStepMedia(backendStep, false));
            break;
        }
      }
      break;
    }
  }

version: string;
public toggleStepAccordion(step) {
  // Loop through all subsections
  if(step !== null)
  {
  let openSubSection = null;
  this.subSections.forEach((subSection) => {
     subSection.steps.forEach((stp) => {
        if(stp.stepId === step.stepId) {
          stp.accordionOpen = step.accordionOpen;
          if (step.accordionOpen) {
            openSubSection = subSection;
          }
          this.replaceArrayContents(this.previewCompliantImages);
          this.replaceArrayContents(this.previewNotCompliantImages);
          if(stp?.media?.length) {
            this.syncStepMediaOrderAndNames(stp);
            
            switch(stp.answer) {
              case 1: // Compliant
                this.replaceArrayContents(this.previewCompliantImages, this.getOrderedStepMedia(stp, true));
                break;
              case 2: // Not Compliant
                this.replaceArrayContents(this.previewNotCompliantImages, this.getOrderedStepMedia(stp, false));
                break;
            }
          }
        }
        else
          stp.accordionOpen = false;
      });    
    });
    
    // Update breadcrumb based on accordion state
    if (step.accordionOpen && openSubSection) {
      this.currentBreadcrumb = {
        sectionName: this.selectedSection?.sectionName || '',
        subSectionName: openSubSection?.subSectionName || '',
        stepName: step?.stepBody || '',
        isVisible: true
      };
    } else {
      this.currentBreadcrumb.isVisible = false;
    }
    
    this.changeDetectorRef.detectChanges();
  }
}

/**
* Deletes subsection
* 
* @param subsection 
* @param index 
*/
public deleteSubsection(subsection, index: number) {
  let subSectionId: any;
  if(subsection.subSectionId)  {
    this.subSections.forEach((element, i) => {
      if (element.subSectionId == subsection.subSectionId) {
        subSectionId = element.subSectionId;
        this.subSections.splice(index, 1);
        return;
      }
    });
    if(this.fromLibrary)
    {
      const payload = {
        type: 'subsection',
        id: subsection.subSectionId
      };
      this.backendService.deleteTemplateRoadmap(payload).subscribe(
        (data: any) => {
          if (data.statusCode == 200) {
            this.toastService.presentToast(
              this.translate.instant('customer_management_deleted_successfully', { entity: this.translate.instant('Subsection') }),
              4000,
              AppConstants.SUCCESS_SNACKBAR,
              'top'
            );
            } else {
            this.toastService.presentToast(
              this.translate.instant('customer_management_delete_failed', { entity: this.translate.instant('Subsection') }),
              4000,
              AppConstants.ERROR_SNACKBAR,
              'top'
            );
          }          
        },
        err => {
          this.toastService.presentToast(err.message, 4000, AppConstants.ERROR_SNACKBAR, 'top', 'error_occurred');
        }
      );
    }
    else
    {
      const payload = {
        id: this.roadmapId,
        serviceMachineId: this.serviceMachineId,
        projectId: this.project_id,
        section: [{
          sectionId: this.sectionId,
          isDelete: false,
          subSection: [{
            subSection_Id: subSectionId,
            isDelete: true,
            steps: [{
              id: '',
              isDelete: false
            }]
          }]
        }]
      };
      this.backendService.deleteRoadmapSectionsData(payload).subscribe(
        (data: any) => {
          this.toastService.presentToast(
            this.translate.instant('customer_management_deleted_successfully', { entity: this.translate.instant('Subsection') }),
            4000,
            AppConstants.SUCCESS_SNACKBAR,
            'top'
          );
          this.onSave(null,null,this.sections[this.selectedIndex]);
        },
        err => {
          this.toastService.presentToast(err.message, 4000, AppConstants.ERROR_SNACKBAR, 'top', 'error_occurred');
        }
      );
    }
  }else {
    this.subSections.splice(index, 1);
  }

}

  fnExitHazardDetails(_event) {   
    const returnStepId = String(_event || this.pendingHazardReturnState?.stepId || '');
    if (returnStepId) {
      if (this.pendingHazardReturnState) {
        this.pendingHazardReturnState.stepId = returnStepId;
      } else {
        this.pendingHazardReturnState = { scrollTop: this.lastRightScrollTop, stepId: returnStepId };
      }
    }
    sessionStorage.removeItem(StorageKeys.READONLY_ROADMAP_DATA);
    this.showHazardDetails = false;
    this.notifyHazardDetailsChange();
    this.openStepById(returnStepId);
    this.changeDetectorRef.detectChanges();
    this.fnViewRoadmap(null);   
  }

/**
* Deletes step
* 
* @param step 
* @param index 
* @param event 
*/
public deleteStep(step, index: number, event: Event) {
  event.stopPropagation();
  let subSectionId: any;
  if(step.stepId)  {
    this.subSections.forEach(element => {
      subSectionId = element.subSectionId;
      element.steps.forEach((eachStep, i) => {
        if (step.stepId === eachStep.stepId) {
          element.steps.splice(i, 1);
        }
      });
    });
    if(this.fromLibrary)
    {
        const payload = {
          type: 'step',
          id: step.stepId
        };
        this.backendService.deleteTemplateRoadmap(payload).subscribe(
          (data: any) => {
            if (data.statusCode == 200) {
              this.toastService.presentToast(
                this.translate.instant('customer_management_deleted_successfully', { entity: this.translate.instant('step') }),
                4000,
                AppConstants.SUCCESS_SNACKBAR,
                'top'
              );
              } else {
              this.toastService.presentToast(
                this.translate.instant('customer_management_delete_failed', { entity: this.translate.instant('step') }),
                4000,
                AppConstants.ERROR_SNACKBAR,
                'top'
              );
            }            
          },
          err => {
            this.toastService.presentToast(err.message, 4000, AppConstants.ERROR_SNACKBAR, 'top', 'error_occurred');
          }
        );
    }
    else
    {
    const payload = {
      id: this.roadmapId,
      serviceMachineId: this.serviceMachineId,
      projectId: this.project_id,
      section: [
        {
          sectionId: this.sectionId,
          isDelete: false,
          subSection: [
            {
              subSection_Id: subSectionId,
              isDelete: false,
              steps: [
                {
                  id: step.stepId,
                  isDelete: true
                }
              ]
            }
          ]
        }
      ]
    };
    this.backendService.deleteRoadmapSectionsData(payload).subscribe(
      (data: any) => {
        this.toastService.presentToast(
          this.translate.instant('customer_management_deleted_successfully', { entity: this.translate.instant('step') }),
          4000,
          AppConstants.SUCCESS_SNACKBAR,
          'top'
        );
        this.onSave(null,null,this.sections[this.selectedIndex]);
      },
      (err) => {
        this.toastService.presentToast(err.message, 4000, AppConstants.ERROR_SNACKBAR, 'top', 'error_occurred');
      }
    );
   }
  }else {
    this.subSections.forEach((element, i) => {
      element.steps.splice(index, 1)
    });
  }
}

/**
 * Adds new section
 */
public addNewSection(selectedSection) {
  if (!this.startCreateLock('subSection')) {
    return;
  }

  this.saveRightScrollPosition();
  const newSubSection = {
    subSection_Id: '',
    subSectionName: this.getNextUniqueSubSectionName(),
    steps: []
  };
  this.isSaveDisabled = false
  this.subSections.push(newSubSection);
  this.onSave(null,newSubSection,this.sections[this.selectedIndex], undefined, undefined, 'add-subsection');
  setTimeout(() => this.restoreRightScrollPosition());
}

/**
 * Adds new step
 * 
 * @param subSectionIndex 
 */
public addNewStep(subSectionIndex: number,subSection,selectedSection) {
  if (!this.startCreateLock('step')) {
    return;
  }

   this.saveRightScrollPosition();
  const newStep = {
    id: '',
    stepBody: this.getNextUniqueStepName(this.subSections[subSectionIndex]),
    padLock: false,
    createdDate: new Date().toISOString(),
    answers : [{ selectedValue: '' ,selectColorClass: ''}],
    hazardCount: 0,
    accordionOpen: false
  };
  this.isSaveDisabled = false
  this.subSections[subSectionIndex].steps.push(newStep);
  this.onSave(newStep,subSection,this.sections[this.selectedIndex], undefined, undefined, 'add-step');
  setTimeout(() => this.restoreRightScrollPosition());
}

/**
 * Gets answer
 * 
 * @param step 
 * @returns selectedValue
 */
getAnswer(step: any): string {
   const optionMapping: { [key: number]: string } = {
    1: "yesCompliant",
    2: "notCompliant",
    3: "notApplicable",
    4: "hazard",
  };
  return optionMapping[step.answer] || "";
}

isRoadMapNameValid = true;

validateDuplicateRoadmapName(
  roadmapName: string,
  roadmapId: string,
  roadmapList: any[]
): boolean {
  if (!roadmapName || !Array.isArray(roadmapList) || roadmapList.length === 0) {
    return false; 
  }

  return roadmapList.some(item =>
    item?.roadmapName === roadmapName && item?.id !== roadmapId
  );
}

onSave(step,subSection,selectedSection, isDeleteImage?, imageId?, saveContext?: 'add-section' | 'add-subsection' | 'add-step', skipRoadmapRefresh = false)
{
  const localChangeSeq = ++this.roadmapLocalChangeSeq;
  
  // CRITICAL: Prevent duplicate roadmap creation by blocking operations with empty roadmapId
  // Only the initial "add-section" can have empty roadmapId (creates new roadmap)
  // All other operations MUST have a valid roadmapId from the first save
  if (saveContext !== 'add-section' && (!this.roadmapId || this.roadmapId.trim() === '')) {
    this.releaseCreateLock(saveContext);
    this.toastService.presentToast(
      this.translate.instant('saving_changes'),
      3000,
      AppConstants.WARNING_SNACKBAR,
      'top'
    );
    return;
  }
  
  if(this.roadmapName.trim() === '') 
  {
    this.releaseCreateLock(saveContext);
    this.isRoadMapNameValid = false;
    return;
  }
  else if(this.validateDuplicateRoadmapName(this.roadmapName,this.roadmapId,this.roadmapList))
  {
    this.releaseCreateLock(saveContext);
    this.toastService.presentToast(this.translate.instant('roadmap_name_already_exists'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
     return;
  }
  else if (selectedSection?.sectionName && this.hasDuplicateName('section', selectedSection.sectionName, selectedSection))
  {
    this.releaseCreateLock(saveContext);
    this.showDuplicateNameToast('section');
    return;
  }
  else if (subSection?.subSectionName && this.hasDuplicateName('subsection', subSection.subSectionName, subSection))
  {
    this.releaseCreateLock(saveContext);
    this.showDuplicateNameToast('subsection');
    return;
  }
  else if (step?.stepBody && this.isDuplicateStepName(step.stepBody, subSection, step))
  {
    this.releaseCreateLock(saveContext);
    this.showDuplicateNameToast('step');
    return;
  }
  else
  {
  this.saveRightScrollPosition();
    let payload: any = {    
      roadmapId: this.roadmapId,
      isCustom: this.isCustom,    
      projectId: this.project_id,
      version: "0",
      roadmapName: this.roadmapName.trim(),
      serviceMachineId: this.serviceMachineId || sessionStorage.getItem('selectedServiceIdNonSAP'),
      userId: this.userInfo.userId,
      userName: this.userInfo.name,
      isServiceRoadmap : !this.isMachineBased && !this.fromLibrary,
      isTemplateRoadmap : this.fromLibrary,
      sectionId : selectedSection.sectionId,
      sectionName: selectedSection.sectionName,
      subSectionId: subSection?.subSectionId,
      subSectionName:subSection?.subSectionName,
      stepId:step?.stepId,
      stepBody:step?.stepBody,
      stepNote:step?.stepNotes,
      answer: this.fromLibrary ? 0 : (step?.answer ?? 0),
      padLock: step?.padLock || false,
      media: isDeleteImage
      ? (step?.media || []).filter(img => img.id !== imageId)
      : (step?.media || []),
      hazard:{}     
  };
  
  const shouldStop = step?.answer === 2 && (!step?.stepNotes || step?.stepNotes.trim() === '')
  if (shouldStop) {
    this.releaseCreateLock(saveContext);
    this.toastService.presentToast(this.translate.instant('notes_required_for_not_compliant_steps'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
    step.stepNotesChange=true;
    return;
  } 
  else
  {
    this.backendService.extendRoadmapv1(payload).subscribe(
      async (res: any) => {
        if ((res.statusCode === 200)) {     
          if(this.roadmapId == '')
            this.roadmapId = res.response.roadmapId;
          
          // Update _originalFileName for all images on successful save
          if (step?.media && step.media.length > 0) {
            step.media.forEach(img => {
              img._originalFileName = img.fileName;
            });
          }

          const successMessage = this.fromLibrary
            ? 'Template Roadmap Updated and Responses are Saved.'
            : 'Roadmap Updated and Responses are Saved';

          this.toastService.presentToast(successMessage, 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
        } else {
          this.releaseCreateLock(saveContext);
          this.toastService.presentToast(res.message, 4000, AppConstants.ERROR_SNACKBAR, 'top');
          return;
        }

        if(selectedSection?.sectionId == '')
              selectedSection.sectionId = res.response.sectionId;  
        
        if (step?.stepNotesChange) step.stepNotesChange = false;

        if (skipRoadmapRefresh) {
          this.releaseCreateLock(saveContext);
          return;
        }

        this.backendService.roadmapExecution(this.roadmapId,selectedSection.sectionId,this.fromLibrary).subscribe(
          async (res: any) => {
            if ((res.statusCode === 200)) {     
              const shouldRestoreImageTarget = !!this.pendingImageRestore;
              this.applyRoadmapExecutionResponse(res.response, localChangeSeq !== this.roadmapLocalChangeSeq);
              this.changeDetectorRef.detectChanges();
              if (!shouldRestoreImageTarget) {
                this.toggleStepAccordion(step);
                this.changeDetectorRef.detectChanges();
                this.restorePendingFocus();
              }
              // Refresh preview arrays directly from backend data so that multi-batch
              // uploads never leave stale IDs in the arrays (preserveLocalValues can
              // keep old media on the local step object, causing delete to use wrong IDs).
              this.refreshPreviewArraysFromResponse(res.response?.sectionDetails || [], step);
              this.changeDetectorRef.detectChanges();
              this.restorePendingImageFocus();
            }
            this.releaseCreateLock(saveContext);
          },
          () => {
            this.releaseCreateLock(saveContext);
          }
        );
      },
      (err) => {
        this.releaseCreateLock(saveContext);
        // HTTP 400 errors come here - check if it's a duplicate image name error
        if (err.status === 400) {
          const errorMessage = err.error?.message || 'error_occurred';
          console.log("Error message:", errorMessage);
          this.toastService.presentToast(errorMessage, 4000, AppConstants.ERROR_SNACKBAR, 'top', 'error_occurred');
          
          // Restore original file names for all images in step.media
          if (step?.media && step.media.length > 0) {
            step.media.forEach(img => {
              if (img._originalFileName) {
                img.fileName = img._originalFileName;
              }
            });
            this.changeDetectorRef.detectChanges();
          }
        } else {
          this.toastService.presentToast('failed_to_save_data', 4000, AppConstants.ERROR_SNACKBAR, 'top');
        }
      }
    );
  }
 }
}

  /**
   * Deletes conformation
   * 
   * @param [data] data
   * @param [index] index
   * @param [event] event
   * @param [itemType] itemType
   */
  public async deleteConfirmation(data?, index?: number, event?: Event, itemType?: string) {
    const itemNameMap = { 'section-kebab': 'Section', 'subsection-kebab': 'Sub section', 'step-kebab': 'step' };
    const itemName = this.translate.instant(itemNameMap[itemType] || '').toLowerCase();
    const title = this.translate.instant('Are_you_sure_you_want_to_delete') + ' ' + itemName + '?';
    const subtitleNameMap = { 'section-kebab': data?.sectionName, 'subsection-kebab': data?.subSectionName, 'step-kebab': data?.stepBody };
    const subtitleName = subtitleNameMap[itemType];
    const subtitle = subtitleName ? `'${subtitleName}'` : null;
    const actionText = this.translate.instant('Delete');
    const isConfirmed = await this.confirmationService.presentConfirmationModal(
      title,
      actionText,
      true,
      this.translate.instant('Cancel'),
      subtitle
    );
    if (isConfirmed) {
      if (itemType == 'section-kebab') {
        this.deleteSection(data, index, event);
      } else if (itemType == 'subsection-kebab') {
        this.deleteSubsection(data, index);
      } else if (itemType == 'step-kebab') {
        this.deleteStep(data, index, event);
      }     

    }
  }

  /**
   * Show slide for a given carousel type
   * @param index - Target slide index
   * @param type - 'compliant' or 'notCompliant'
   */
  public showSlide(index: number, type: 'compliant' | 'notCompliant'): void {
    const carouselMetrics = this.getCarouselMetrics(type);
    if (!carouselMetrics) {
      return;
    }

    const maxIndex = Math.max(0, this.getCarouselItemsLength(type) - Math.ceil(this.carouselVisibleItems(type)));
    const boundedIndex = Math.max(0, Math.min(index, maxIndex));

    carouselMetrics.container.scrollTo({ left: boundedIndex * carouselMetrics.itemWidth, behavior: 'smooth' });
    this.currentIndex = boundedIndex;
  }

  /**
   * Move to the next slide with optional looping
   * @param type - 'compliant' or 'notCompliant'
   */
  public nextSlide(type: 'compliant' | 'notCompliant'): void {
    const carouselMetrics = this.getCarouselMetrics(type);
    if (!carouselMetrics) {
      return;
    }

    this.scrollCarouselByStep(carouselMetrics.container, carouselMetrics.itemWidth, 1);
  }

  /**
   * Move to the previous slide
   * @param type - 'compliant' or 'notCompliant'
   */
  public prevSlide(type: 'compliant' | 'notCompliant'): void {
    const carouselMetrics = this.getCarouselMetrics(type);
    if (!carouselMetrics) {
      return;
    }

    this.scrollCarouselByStep(carouselMetrics.container, carouselMetrics.itemWidth, -1);
  }

  /**
   * Calculate visible items
   */
  private carouselVisibleItems(type: 'compliant' | 'notCompliant'): number {
    const carouselMetrics = this.getCarouselMetrics(type);
    if (!carouselMetrics) {
      return 1;
    }

    return Math.max(1, Math.floor(carouselMetrics.container.clientWidth / carouselMetrics.itemWidth));
  }

  private getCarouselContainer(type: 'compliant' | 'notCompliant'): HTMLElement | null {
    return document.querySelector(`.ra-carousel-viewport[data-carousel-type="${type}"]`) as HTMLElement | null;
  }

  private getCarouselItemWidth(carouselContainer: HTMLElement): number {
    const carouselItem = carouselContainer.querySelector('.ra-carousel-item') as HTMLElement | null;
    return carouselItem?.clientWidth || 0;
  }

  private getCarouselItemsLength(type: 'compliant' | 'notCompliant'): number {
    return type === 'compliant' ? this.previewCompliantImages.length : this.previewNotCompliantImages.length;
  }

  private getCarouselMetrics(type: 'compliant' | 'notCompliant'): { container: HTMLElement; itemWidth: number } | null {
    const container = this.getCarouselContainer(type);
    if (!container) {
      return null;
    }

    const itemWidth = this.getCarouselItemWidth(container);
    if (!itemWidth) {
      return null;
    }

    return { container, itemWidth };
  }

  private scrollCarouselByStep(carouselContainer: HTMLElement, itemWidth: number, direction: 1 | -1): void {
    const targetLeft = direction > 0
      ? Math.min(carouselContainer.scrollLeft + itemWidth, carouselContainer.scrollWidth - carouselContainer.clientWidth)
      : Math.max(carouselContainer.scrollLeft - itemWidth, 0);

    carouselContainer.scrollTo({ left: targetLeft, behavior: 'smooth' });
  }

  private canCarouselSwipe(type: 'compliant' | 'notCompliant'): boolean {
    const carouselMetrics = this.getCarouselMetrics(type);
    if (!carouselMetrics) {
      return false;
    }

    return carouselMetrics.container.scrollWidth > carouselMetrics.container.clientWidth;
  }

  private isCarouselInteractiveTarget(target: EventTarget | null): boolean {
    if (!(target instanceof Element)) {
      return false;
    }

    return !!target.closest('input, textarea, button, ion-button, ion-icon, a, [role="button"], .delete-icon, .image-name-input');
  }

  public onCarouselPointerDown(event: PointerEvent, type: 'compliant' | 'notCompliant'): void {
    if (event.button !== 0 || !this.canCarouselSwipe(type) || this.isCarouselInteractiveTarget(event.target)) {
      return;
    }

    const carouselContainer = this.getCarouselContainer(type);
    if (!carouselContainer) {
      return;
    }

    event.preventDefault();
    this.activePointerCarouselType = type;
    this.carouselPointerStartX = event.clientX;
    this.carouselPointerStartScrollLeft = carouselContainer.scrollLeft;
    carouselContainer.setPointerCapture?.(event.pointerId);
  }

  public onCarouselPointerMove(event: PointerEvent): void {
    if (!this.activePointerCarouselType) {
      return;
    }

    const carouselContainer = this.getCarouselContainer(this.activePointerCarouselType);
    if (!carouselContainer) {
      return;
    }

    event.preventDefault();
    const deltaX = event.clientX - this.carouselPointerStartX;
    carouselContainer.scrollLeft = this.carouselPointerStartScrollLeft - deltaX;
  }

  public onCarouselPointerUp(event: PointerEvent): void {
    if (!this.activePointerCarouselType) {
      return;
    }

    const carouselContainer = this.getCarouselContainer(this.activePointerCarouselType);
    carouselContainer?.releasePointerCapture?.(event.pointerId);
    this.activePointerCarouselType = null;
  }

  public onCarouselWheel(event: WheelEvent, type: 'compliant' | 'notCompliant'): void {
    if (!this.canCarouselSwipe(type)) {
      return;
    }

    const carouselContainer = this.getCarouselContainer(type);
    if (!carouselContainer) {
      return;
    }

    const dominantDelta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
    if (!dominantDelta) {
      return;
    }

    event.preventDefault();
    carouselContainer.scrollLeft += dominantDelta;
  }

  private getMediaOrderNo(image: any, index: number): number {
    const rawOrderNo = image?.orderNo ?? image?.orderNO ?? image?.order_no ?? image?.orderno ?? image?.order;
    const parsedOrderNo = Number(rawOrderNo);
    return Number.isFinite(parsedOrderNo) ? parsedOrderNo : index + 1;
  }

  private isMediaForCompliance(image: any, isCompliant: boolean): boolean {
    if (typeof image?.isCompliant === 'boolean') {
      return image.isCompliant === isCompliant;
    }

    if (typeof image?.isComplaint === 'boolean') {
      return image.isComplaint === isCompliant;
    }

    if (typeof image?.yesComplaint === 'boolean') {
      return image.yesComplaint === isCompliant;
    }

    const resourceType = Number(image?.resourceType ?? image?.resource_type ?? image?.type);
    if (isCompliant) {
      return resourceType === 5;
    }

    return resourceType === 6;
  }

  private getOrderedStepMedia(step: any, isCompliant: boolean): any[] {
    const media = Array.isArray(step?.media) ? step.media : [];
    const filtered = media.filter((img: any) => this.isMediaForCompliance(img, isCompliant));
    const originalIndex = new Map<any, number>(filtered.map((img: any, idx: number) => [img, idx]));

    return [...filtered].sort((a: any, b: any) => {
      const aIsView = a?.is_view ? 1 : 0;
      const bIsView = b?.is_view ? 1 : 0;
      if (aIsView !== bIsView) {
        return aIsView - bIsView;
      }

      const aOrderNo = this.getMediaOrderNo(a, originalIndex.get(a) ?? 0);
      const bOrderNo = this.getMediaOrderNo(b, originalIndex.get(b) ?? 0);
      if (aOrderNo !== bOrderNo) {
        return aOrderNo - bOrderNo;
      }

      return (originalIndex.get(a) ?? 0) - (originalIndex.get(b) ?? 0);
    });
  }

  private getEditableStepImages(step: any, isCompliant?: boolean): any[] {
    const images = step?.media || [];

    return images.filter((img: any) => {
      if (img?.is_view) {
        return false;
      }

      if (isCompliant === undefined) {
        return true;
      }

      return this.isMediaForCompliance(img, isCompliant);
    });
  }

  private normalizeRoadmapImageName(fileName: string): string {
    return (fileName || '').trim().toLowerCase();
  }

  private isDefaultRoadmapImageName(fileName: string): boolean {
    return /^Image\s*\d+$/i.test(String(fileName || '').trim());
  }

  private getIsCompliantFromImageType(type: string, currentImage?: any): boolean | undefined {
    if (type === 'compliant') {
      return true;
    }

    if (type === 'notCompliant') {
      return false;
    }

    if (typeof currentImage?.isCompliant === 'boolean') {
      return currentImage.isCompliant;
    }

    return undefined;
  }

  private isDuplicateRoadmapImageName(step: any, candidateName: string, type: string, currentImage?: any): boolean {
    const normalizedCandidateName = this.normalizeRoadmapImageName(candidateName);
    const isCompliant = this.getIsCompliantFromImageType(type, currentImage);

    if (!normalizedCandidateName) {
      return false;
    }

    const matchingImages = this.getEditableStepImages(step, isCompliant).filter((img: any) => {
      if (currentImage && img?.id === currentImage?.id && img?.url === currentImage?.url) {
        return false;
      }

      return this.normalizeRoadmapImageName(img?.fileName) === normalizedCandidateName;
    });

    if (!matchingImages.length) {
      return false;
    }

    // Only block a rename when the target name is already in use by a different
    // yes-compliant or not-compliant image. Valid default-image moves like
    // "Image 1" -> "Image 9" are allowed when that target name does not exist.
    const isDefaultCandidate = this.isDefaultRoadmapImageName(candidateName);
    if (isDefaultCandidate) {
      const targetNameExists = matchingImages.some((img: any) => this.isDefaultRoadmapImageName(img?.fileName));
      return targetNameExists;
    }

    return true;
  }

  /**
   * Creates an image number allocator for a single upload batch.
    * Allocates order numbers in append-only sequence (max + 1) for the batch,
    * so deleted numbers are not reused and uploads feel gapless over time.
    * Uses the highest valid existing orderNo and default-style name "Image N"
    * (Int32-safe only) to determine the next number.
   */
  private createImageNumberAllocator(step: any, isCompliant: boolean): () => number {
    // Use the same compliance detector as the display path (isMediaForCompliance),
    // not a strict isCompliant check, because reloaded images may carry
    // resourceType/isComplaint instead of the isCompliant boolean.
    const media = Array.isArray(step?.media) ? step.media : [];
    const existingImages = media.filter(
      (img: any) => !img?.is_view && this.isMediaForCompliance(img, isCompliant)
    );

    const INT32_MAX = 2147483647;
    const usedOrderNumbers = new Set<number>();
    let maxDefaultNameNo = 0;

    existingImages.forEach((img: any) => {
      const rawOrderNo = img?.orderNo ?? img?.orderNO ?? img?.order_no ?? img?.orderno ?? img?.order;
      const orderNo = Number(rawOrderNo);
      if (
        Number.isInteger(orderNo)
        && orderNo > 0
        && orderNo <= INT32_MAX
      ) {
        usedOrderNumbers.add(orderNo);
      }

      const nameMatch = String(img?.fileName || '').trim().match(/^Image\s*(\d+)$/i);
      if (nameMatch) {
        const nameNo = Number(nameMatch[1]);
        if (
          Number.isInteger(nameNo)
          && nameNo > 0
          && nameNo <= INT32_MAX
          && nameNo > maxDefaultNameNo
        ) {
          maxDefaultNameNo = nameNo;
        }
      }
    });

    let maxOrderNo = 0;
    usedOrderNumbers.forEach((value) => {
      if (value > maxOrderNo) {
        maxOrderNo = value;
      }
    });

    let nextCandidate = Math.max(maxOrderNo, maxDefaultNameNo) + 1;
    if (nextCandidate > INT32_MAX) {
      // Extremely defensive overflow fallback.
      nextCandidate = maxOrderNo + 1;
    }

    return () => {
      const allocated = nextCandidate > INT32_MAX ? INT32_MAX : nextCandidate;
      usedOrderNumbers.add(allocated);
      nextCandidate = allocated + 1;
      return allocated;
    };
  }

  /**
   * Uploads compliant images
   */
  public async uploadCompliantImages(step, subSection, selectedSection) {
    this.replaceArrayContents(this.previewCompliantImages);
    const file_path = `${this.queryParams.project_Id}/${this.queryParams.serviceId}/${this.queryParams.machineId}/${this.roadmapId}/`;
    const formData = new FormData();
    const hazardImageFormData = this.sharedValue.prepareImageFormData(formData, this.imageFiles, file_path)
    await this.backendService.uploadImages(hazardImageFormData).subscribe((res: any) => {
      step.media = step.media || [];
      const nextImageNumber = this.createImageNumberAllocator(step, true);
      res.forEach(element => {
        const orderNo = nextImageNumber();
        const imageData = {
          id: element?.id || '',
          fileName: `Image ${orderNo}`,
          contentType: element?.content_type,
          url: element?.url,
          image_Size: element?.file_size,
          driveId: '',
          itemId: '',
          is_Primary: true,
          isActive: true,
          isCompliant: true,
          orderNo
        };
        step.media.push({ ...imageData });
        this.hazardImagesList.push(imageData);
      });
      this.replaceArrayContents(this.previewCompliantImages, this.getOrderedStepMedia(step, true));
      this.fnStepBodyChanges(step, subSection, selectedSection);
    }, (err) => {
    });
  }

  /**
   * Inputs compliant img
   * 
   * @param files 
   * @param compliantImage 
   */
  public async inputCompliantImg(files: File[], compliantImage: HTMLInputElement, step, subSection, selectedSection) {
    this.saveRightScrollPosition();
    this.rememberPendingFocus('image-upload', subSection, step, 5);
    const validFiles = this.validateRoadmapImageFiles(files, compliantImage);
    if (!validFiles.length) {
      setTimeout(() => this.restoreRightScrollPosition());
      return;
    }

    this.pendingRoadmapImageUpload = {
      files: validFiles,
      type: 'compliant',
      step,
      subSection,
      selectedSection,
    };

    compliantImage.value = '';
    await this.showRoadmapImageUploadConfirmation();
    setTimeout(() => this.restoreRightScrollPosition());
  }

  /**
   * Inputs not compliant img
   * @param files
   * @param notCompliantImage
   * @param step
   */
  public async inputNotCompliantImg(files: File[], notCompliantImage: HTMLInputElement, step, subSection, selectedSection) {
      this.saveRightScrollPosition(); 
      this.rememberPendingFocus('image-upload', subSection, step, 6);
      const validFiles = this.validateRoadmapImageFiles(files, notCompliantImage);
      if (!validFiles.length) {
        setTimeout(() => this.restoreRightScrollPosition());
        return;
      }

      this.pendingRoadmapImageUpload = {
        files: validFiles,
        type: 'notCompliant',
        step,
        subSection,
        selectedSection,
      };

      notCompliantImage.value = '';    
      await this.showRoadmapImageUploadConfirmation();
      setTimeout(() => this.restoreRightScrollPosition());  
  }

  public async onCompliantImagesSelected(event: ImageUploadEvent, step, subSection, selectedSection) {
    const files: File[] = event?.files || [];
    if (!files.length) {
      return;
    }

    await this.inputCompliantImg(files, {} as HTMLInputElement, step, subSection, selectedSection);
  }

  public async onNotCompliantImagesSelected(event: ImageUploadEvent, step, subSection, selectedSection) {
    const files: File[] = event?.files || [];
    if (!files.length) {
      return;
    }

    await this.inputNotCompliantImg(files, {} as HTMLInputElement, step, subSection, selectedSection);
  }

  private validateRoadmapImageFiles(files: File[] | FileList, imageInput: HTMLInputElement): File[] {
    const initialFiles = Array.from(files || []);
    const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];

    for (const file of initialFiles) {
      if (!allowedTypes.includes(file.type)) {
        this.toastService.presentToast(
          this.translate.instant('image_file_types_allowed_msg'),
          4000,
          AppConstants.WARNING_SNACKBAR,
          'top'
        );
        if (imageInput?.value !== undefined) {
          imageInput.value = '';
        }
        return [];
      }

      if (!file?.name || file.name.trim().length === 0 || file.name.length > 100) {
        this.toastService.presentToast(
          this.translate.instant('image_name_validation'),
          4000,
          AppConstants.WARNING_SNACKBAR,
          'top'
        );
        if (imageInput?.value !== undefined) {
          imageInput.value = '';
        }
        return [];
      }
    }

    const validSizeFiles = initialFiles.filter(file => file.size <= this.MAX_ROADMAP_IMAGE_SIZE);
    const oversizedCount = initialFiles.length - validSizeFiles.length;
    if (oversizedCount > 0) {
      const maxMB = (this.MAX_ROADMAP_IMAGE_SIZE / (1024 * 1024)).toFixed(0);
      this.toastService.presentToast(
        this.translate.instant('image_size_exceeds_limit', { count: oversizedCount, max: maxMB }),
        4000,
        AppConstants.WARNING_SNACKBAR,
        'top'
      );
    }

    if (imageInput?.value !== undefined) {
      imageInput.value = '';
    }

    return validSizeFiles;
  }

  private async showRoadmapImageUploadConfirmation(): Promise<void> {
    if (!this.pendingRoadmapImageUpload?.files?.length) {
      return;
    }

    const pendingUpload = this.pendingRoadmapImageUpload;
    const modal = await this.modalController.create({
      component: UploadConfirmationModalComponent,
      cssClass: 'upload-confirmation-modal',
      backdropDismiss: false,
      componentProps: {
        imageCount: pendingUpload.files.length,
      },
      showBackdrop: true,
    });
    await modal.present();

    const { data } = await modal.onDidDismiss<UploadConfirmationResult>();
    const action = data?.action ?? 'cancel';

    if (action === 'cancel') {
      this.pendingRoadmapImageUpload = null;
      return;
    }

    if (action === 'upload') {
      await this.processRoadmapImagesAndUpload(pendingUpload.files, pendingUpload);
      this.pendingRoadmapImageUpload = null;
      return;
    }

    if (action === 'edit') {
      const editedFiles: File[] = await this.imageEditorService.openBatch(pendingUpload.files, {
        exportFormat: 'jpeg',
        exportQuality: 0.92,
      });

      this.pendingRoadmapImageUpload = null;

      if (!editedFiles.length) {
        return;
      }

      const validSizeEditedFiles = editedFiles.filter(file => file.size <= this.MAX_ROADMAP_IMAGE_SIZE);
      const oversizedEditedCount = editedFiles.length - validSizeEditedFiles.length;
      if (oversizedEditedCount > 0) {
        const maxMB = (this.MAX_ROADMAP_IMAGE_SIZE / (1024 * 1024)).toFixed(0);
        this.toastService.presentToast(
          this.translate.instant('image_size_exceeds_limit', { count: oversizedEditedCount, max: maxMB }),
          4000,
          AppConstants.WARNING_SNACKBAR,
          'top'
        );
      }

      if (!validSizeEditedFiles.length) {
        return;
      }

      await this.processRoadmapImagesAndUpload(validSizeEditedFiles, pendingUpload);
    }
  }

  private async processRoadmapImagesAndUpload(
    files: File[],
    pendingUpload: {
      files: File[];
      type: 'compliant' | 'notCompliant';
      step: any;
      subSection: any;
      selectedSection: any;
    },
  ): Promise<void> {
    this.imageFiles = files;
    this.isSaveDisabled = false;
    const self = this;

    for (const file of files) {
      const reader = new FileReader();
      const imgData = {
        fileName: file.name,
        fileSize: file.size,
        fileReaderResult: reader.result,
        fileData: file,
      };

      reader.onload = () => {
        self.reviewImageSrc = reader.result;
        imgData.fileReaderResult = reader.result;
      };

      reader.readAsDataURL(file);
    }

    if (pendingUpload.type === 'compliant') {
      await this.uploadCompliantImages(pendingUpload.step, pendingUpload.subSection, pendingUpload.selectedSection);
      return;
    }

    await this.uploadNotCompliantImages(pendingUpload.step, pendingUpload.subSection, pendingUpload.selectedSection);
  }

  /**
   * Uploads not compliant images
   */
  public async uploadNotCompliantImages(step, subSection, selectedSection) {
    this.replaceArrayContents(this.previewNotCompliantImages);
    const file_path = `${this.queryParams.project_Id}/${this.queryParams.serviceId}/${this.queryParams.machineId}/${this.roadmapId}/`;
    const formData = new FormData();
    const hazardImageFormData = this.sharedValue.prepareImageFormData(formData, this.imageFiles, file_path)
    await this.backendService.uploadImages(hazardImageFormData).subscribe((res: any) => {
      //step.media = [];
      step.media = step.media || [];
      const nextImageNumber = this.createImageNumberAllocator(step, false);
      res.forEach(element => {
        const orderNo = nextImageNumber();
        const imageData = {
          id: element?.id || '',
          fileName: `Image ${orderNo}`,
          contentType: element?.content_type,
          url: element?.url,
          image_Size: element?.file_size,
          driveId: '',
          itemId: '',
          is_Primary: true,
          isActive: true,
          isCompliant: false,
          orderNo
        };
        step.media.push({ ...imageData });
        this.hazardImagesList.push(imageData);
      });
      this.replaceArrayContents(this.previewNotCompliantImages, this.getOrderedStepMedia(step, false));
      this.fnStepBodyChanges(step, subSection, selectedSection);
    }, (err) => {
    });
  }

  public async onClickKebab(data, index, ev, type, subsection?) {    
    const triggerElement = (ev?.currentTarget as HTMLElement) || (ev?.target as HTMLElement) || null;
    const props = { fromLibrary: this.fromLibrary, type, roadmapViewData: data, triggerElement };
    const popover = await this.popoverController.create({ mode: 'ios',
      component: StatusPopoverComponent,
      cssClass: 'my-custom-class',
      event: ev,
      translucent: true,
      componentProps: props,
      showBackdrop: false
    });
    await popover.present();
    await popover.onDidDismiss().then((result) => {
      if (result.role == 'delete') {
        this.deleteConfirmation(data, index, ev, type)
      } else if (result.role == 'markNotApplicable') {
        this.confirmMarkAsNotApplicable(type, data, subsection?.id)
      }
      else if(result.role == 'duplicate')
      {
        this.duplicateSecSubsection(data,type,ev);
      }
      else if(result.role == 'rename')
      {
        this.renameSectionSubsection(data,type,ev);
      }
    });
  }

  public async renameSectionSubsection(data, type, parentId) {
    const originalName = type === 'section-kebab' ? data?.sectionName : data?.subSectionName;
    const title = AppConstants.RENAME_SECTION;
    const props = {
      title: title,
      section : data
    };
    const modal = await this.modalController.create({
      component: SectionRenameComponent,
      cssClass: 'rename-alert-modal',
      backdropDismiss: false,
      showBackdrop: false,
      componentProps: props,
    });
    await modal.present();
    const modalResult = await modal.onWillDismiss();
    const updatedSection = modalResult?.data?.section || modalResult?.data?.response;
    if (!data) {
      return;
    }

    if (!updatedSection) {
      if (type === 'section-kebab') {
        data.sectionName = originalName;
      } else if (type === 'subsection-kebab') {
        data.subSectionName = originalName;
      }
      return;
    }

    if (type === 'section-kebab') {
      data.sectionName = String(data?.sectionName || '').trim();
    }

    if (type === 'subsection-kebab') {
      data.subSectionName = String(data?.subSectionName || '').trim();
    }

    if (type === 'section-kebab' && this.hasDuplicateName('section', data?.sectionName, data)) {
      data.sectionName = originalName;
      this.showDuplicateNameToast('section');
      this.changeDetectorRef.detectChanges();
      return;
    }

    if (type === 'subsection-kebab' && this.hasDuplicateName('subsection', data?.subSectionName, data)) {
      data.subSectionName = originalName;
      this.showDuplicateNameToast('subsection');
      this.changeDetectorRef.detectChanges();
      return;
    }

    if (type === 'section-kebab') {
      this.onSave(null, null, data);
      return;
    }

    if (type === 'subsection-kebab') {
      this.onSave(null, data, this.selectedSection);
    }
    
  }


  public drop(event: CdkDragDrop<string[]>) {
      if (event.previousIndex !== event.currentIndex) {
          moveItemInArray(this.sections, event.previousIndex, event.currentIndex);
          this.sections.forEach((section, index) => {
            section.order = index + 1;
          });
          this.rearrangeSecSubSection('section');
          console.log('Updated pages:', this.sections);
      }
  }

  public subSectionDrop(event: CdkDragDrop<string[]>,section) {
    if (event.previousIndex !== event.currentIndex) {
        moveItemInArray(this.subSections, event.previousIndex, event.currentIndex);
        this.subSections.forEach((subSection, index) => {
          subSection.order = index + 1;
        });
        this.rearrangeSecSubSection('subsection',section);
        console.log('Updated pages:', this.sections);
    }
}
  roadmapData:any;
  private fnViewRoadmap(step) {
    const hazardReturnState = this.pendingHazardReturnState;
    if (!hazardReturnState) {
      this.saveRightScrollPosition();
    }
    this.backendService.roadmapExecution(this.roadmapId,this.sections[this.selectedIndex].sectionId,this.fromLibrary).subscribe((data: any) => {
        if (data) {
          this.applyRoadmapExecutionResponse(data.response);
          this.toggleStepAccordion(step);
          if (hazardReturnState?.stepId) {
            this.openStepById(hazardReturnState.stepId);
          }
          this.changeDetectorRef.detectChanges();
          if (hazardReturnState) {
            this.restoreRightScrollPosition(hazardReturnState.scrollTop);
            this.pendingHazardReturnState = null;
          } else if (this.pendingFocusTarget) {
            this.restorePendingFocus();
          } else {
            this.restoreRightScrollPosition();
          }
          this.restorePendingImageFocus();
        }           
      }, err => { 
    });    
  }
  
  public rearrangeSecSubSection(type,section?)
  {
    let payload = {
      roadmapId: this.roadmapId,
      sectionId: '', 
      isSection: false,
      sections:[],
      subSections:[]
    };
    switch(type){
          case 'section': {
                            payload.isSection= true;
                            this.sections.forEach(element => {
                              payload.sections.push({ sectionId: element.sectionId, orderNo: element.order});
                            });
                          }
                          break;
          case 'subsection':
                           { 
                            payload.sectionId = section.sectionId;
                            this.subSections.forEach(element => {
                              payload.subSections.push({ subSectionId: element.subSectionId, orderNo: element.order});
                            });
                           }
                        break;
    }
    
    

    this.backendService.rearrangeSecSubsection(payload).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.toastService.presentToast('Reordered Successfully', 4000, AppConstants.SUCCESS_SNACKBAR, 'top');               
          this.fnViewRoadmap(null);
        } else {
          this.toastService.presentToast('Failed to Reorder', 4000, AppConstants.ERROR_SNACKBAR, 'top');
        }          
      },
      err => {
        this.toastService.presentToast(err.message, 4000, AppConstants.ERROR_SNACKBAR, 'top', 'error_occurred');
      }
    ); 
  }

  public duplicateSecSubsection(data, type,event) {
    event.stopPropagation();
    let payload = {};
    switch(type) {
      case 'section-kebab':
        {   
          payload = {
                sectionId: data.sectionId,
                isTemplate: this.fromLibrary,
                serviceMachineId: this.serviceMachineId,
                projectId: this.project_id
              };
                         
        } break; 
      case 'subsection-kebab':
        {
          payload = {
                subSectionId: data.subSectionId,
                isTemplate: this.fromLibrary,
                serviceMachineId: this.serviceMachineId,
                projectId: this.project_id
          };
        } break;     
    }
    this.backendService.duplicateSecSubsection(payload).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.toastService.presentToast(this.translate.instant('roadmap_cloned_successfully'), 4000, AppConstants.SUCCESS_SNACKBAR, 'top');               
          this.fnViewRoadmap(null);
        } else {
          this.toastService.presentToast(this.translate.instant('failed_to_clone_roadmap'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
        }          
      },
      err => {
        this.toastService.presentToast(err.message, 4000, AppConstants.ERROR_SNACKBAR, 'top', 'error_occurred');
      }
    ); 
  }

  public fnMarkAsNotApplicable(type, data) {
    
    let payload = {};
    switch(type) {
      case 'section-kebab':
        {   
          payload = {
                sectionId: data.sectionId,
                serviceMachineId:this.serviceMachineId || sessionStorage.getItem('selectedServiceIdNonSAP'),
                userId:this.userInfo.userId
              };
                         
        } break; 
      case 'subsection-kebab':
        {
          payload = {
                subSectionId: data.subSectionId,
                serviceMachineId:this.serviceMachineId || sessionStorage.getItem('selectedServiceIdNonSAP'),
                userId:this.userInfo.userId
          };
        } break;  
      case 'step-kebab':
        {
          payload = {
                stepId: data.stepId,
                serviceMachineId:this.serviceMachineId || sessionStorage.getItem('selectedServiceIdNonSAP'),
                userId:this.userInfo.userId
          };
        } break;
         
    }
    this.backendService.markAsNotApplicable(payload).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.toastService.presentToast(this.translate.instant('marked_not_applicable_successfully'), 4000, AppConstants.SUCCESS_SNACKBAR, 'top');               
          this.onSave(null,null,this.sections[this.selectedIndex]);
          this.fnViewRoadmap(null);
        } else {
          this.toastService.presentToast(this.translate.instant('failed_to_mark_not_applicable'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
        }          
      },
      err => {
        this.toastService.presentToast(err.message, 4000, AppConstants.ERROR_SNACKBAR, 'top', 'error_occurred');
      }
    ); 
  }
  
  

  public async confirmMarkAsNotApplicable(type, data, parentId) {
    const title = type == 'section-kebab' ? this.translate.instant('mark_section_na_confirm') : type == 'subsection-kebab' ? this.translate.instant('mark_subsection_na_confirm') : this.translate.instant('mark_step_na_confirm');
    const actionText = this.translate.instant('yes');
    const props = {
      confirmationTitle: title,
      actionText, showCancel: true };
    const modal = await this.modalController.create({
      component: ConfirmationModalComponent,
      cssClass: 'small-alert-modal',
      backdropDismiss: false,
      showBackdrop: false,
      componentProps: props,
    });
    await modal.present();
    const { data: { isActionConfirmed } } = await modal.onWillDismiss();
    if (isActionConfirmed) {
      this.markNotApplicable(type, data, parentId)
    }
  }

  public markNotApplicable(
    type: 'section-kebab' | 'subsection-kebab' | 'step-kebab',
    data,
    parentId
  ): void {
    this.fnMarkAsNotApplicable(type, data);    
    this.changeDetectorRef.detectChanges();
  }

  async deleteImageConfirmation(params, type, step, subSection, selectedSection){
    const itemName = this.translate.instant('image').toLowerCase();
    const title = this.translate.instant('Are_you_sure_you_want_to_delete') + ' ' + itemName + '?';
    const subtitle = params?.fileName ? `'${params.fileName}'` : null;
    const actionText = this.translate.instant('Delete');
    const isConfirmed = await this.confirmationService.presentConfirmationModal(
      title,
      actionText,
      true,
      this.translate.instant('Cancel'),
      subtitle
    );
    if (isConfirmed) {
        this.deleteImage(params, type, step, subSection, selectedSection);
   }
  }
  public deleteImage(params, type, step, subSection, selectedSection) {
    this.saveRightScrollPosition();
    this.rememberPendingFocus('image-upload', subSection, step, type);
    const isCompliant = type === 5;
    const remainingImages = this.getEditableStepImages(step, isCompliant)
      .filter((image: any) => !(image?.id === params?.id && image?.url === params?.url));
    const deletedIndex = this.getEditableStepImages(step, isCompliant)
      .findIndex((image: any) => image?.id === params?.id && image?.url === params?.url);
    const restoreImage = remainingImages[Math.min(
      Math.max(deletedIndex, 0),
      Math.max(remainingImages.length - 1, 0)
    )];
    if (restoreImage) {
      this.rememberImageRestoreTarget(subSection, step, type, restoreImage);
    } else {
      this.pendingImageRestore = {
        subSectionKey: this.getSubSectionKey(subSection),
        stepKey: this.getStepKey(step),
        imageType: String(type),
      };
    }
    const  payload =  {
      id: params?.id,
      fileName: params?.fileName,
      filePath: params?.url,
      modifiedBy: this.userAuthService.getUserList().userId,
      orderNo: params?.orderNo
    }
    if(type == 5) payload['resourceType'] = 5;
    else if (type == 6) payload['resourceType'] = 6;
    this.backendService.deleteResource(payload).subscribe((res: any) => {
      if (res?.statusCode == 200) {
        this.fnViewRoadmap(step);        
      }
      this.toastService.presentToast(this.translate.instant('img-deleted-succesfully'), 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
    }, err => {

      this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
    });
    setTimeout(() => this.restoreRightScrollPosition());
  }

  /**
   * Imports roadmap
   */
  public importRoadmap(modeIds?, machineId?, isConfirmCopyHazardLocation: boolean = true) {
    console.log(this.readOnlyRoadmapData, 'readOnlyRoadmapData');
    this.isReadonlyRoadmap = false;
    const queryParams = this.route.snapshot.queryParams;
    const roadmapType = sessionStorage.getItem(StorageKeys.SELECTED_ROADMAP_TYPE);
    this.checkedRoadMapList = [];
    const roadmap = sessionStorage.getItem(StorageKeys.VIEW_ROADMAP);
    const viewedRoadMap = JSON.parse(roadmap);
    this.checkedRoadMapList.push(viewedRoadMap);
    const data = {
      isConfigureRoadmap: true,
      selectedOption: roadmapType,
      selectedPredefinedRoadmapLists: this.checkedRoadMapList,
      modeIds: modeIds || [],
      machineId: machineId,
      isConfirmCopyHazardLocation
    }
    this.router.navigate(
      ['/project-management', 'machine-info', this.queryParams.machineId],
      {
        queryParams,
        state: { action: ObservationEvents.IMPORT_ROADMAP, data: data, timestamp: Date.now() }
      }
    );
  }

  private async presentCloneRoadmapConfirmation(): Promise<boolean | null> {
    const modal = await this.modalController.create({
      component: ConfirmationModalComponent,
      cssClass: 'confirmation-modal',
      backdropDismiss: false,
      showBackdrop: false,
      componentProps: {
        confirmationTitle: this.translate.instant('are_you_sure_you_want_to_import_this_roadmap'),
        actionText: AppConstants.YES,
        showConfirmationCheckbox: !this.isTemplateRoadmap,
        confirmationCheckboxLabel: !this.isTemplateRoadmap ? this.translate.instant('copy_hazard_location') : '',
        isConfirmationCheckboxChecked: true,
        keepTitleInSingleLine: true,
      },
    });

    await modal.present();
    const { data } = await modal.onWillDismiss();
    if (!data?.isActionConfirmed) {
      return null;
    }

    return !!(data.isConfirmationCheckboxChecked ?? data.confirmationCheckboxChecked);
  }

   public async importSelectedRoadmap(modeIds?) {
    const payload = {
      serviceMachineId: this.serviceMachineId, 
      projectId: this.project_id,
      isTemplate: this.isTemplateRoadmap,
      isFromSimilarMachine: this.isTemplateRoadmap ? false : true,
      roadmapIds: this.selectedRoadmapList,
      userEmail: this.userInfo.email,
      userId: this.userInfo.userId
    };
    this.backendService.importedRoadmapValidation(payload).subscribe({
      next: async (res) => {
        const response = res as { statusCode: number; message: string; flag: boolean; response: boolean };
        if (response?.statusCode === 200) {
          const isConfirmCopyHazardLocation = await this.presentCloneRoadmapConfirmation();
          if (isConfirmCopyHazardLocation !== null) {
            this.importRoadmap(modeIds, this.machineId, isConfirmCopyHazardLocation);
          }
        }
      },
      error: async (err) => {
        if (err.error.statusCode === 422) {
          const isConfirmCopyHazardLocation = await this.presentCloneRoadmapConfirmation();
          if (isConfirmCopyHazardLocation !== null) {
            this.importRoadmap(modeIds, this.machineId, isConfirmCopyHazardLocation);
          }
        }
      }
    });
  }

 /**
  * Exits view readonly roadmap
  */
  public exitViewReadonlyRoadmap() {
    sessionStorage.removeItem(StorageKeys.READONLY_ROADMAP_DATA);
    this.isReadonlyRoadmap = false;
    this.router.navigate(['../'], {
      relativeTo: this.route,
      queryParamsHandling: 'preserve',
      state: { action: ObservationEvents.EXIT_ROADMAP, timestamp: Date.now() }
    });
  }

  /**
   * Saves right scroll position
   */
 private saveRightScrollPosition() {
    const container = this.getLiveRightScrollContainer();
    if (container) {
      this.lastRightScrollTop = container.scrollTop;
    }
  }

  private rememberHazardReturnState(step: any): void {
    this.saveRightScrollPosition();
    this.pendingHazardReturnState = {
      scrollTop: this.lastRightScrollTop,
      stepId: String(step?.stepId || ''),
    };
  }

  private getLiveRightScrollContainer(): HTMLElement | undefined {
    const container = this.rightScrollContainer?.nativeElement as HTMLElement | undefined;
    return container?.isConnected ? container : undefined;
  }

  private openStepById(stepId: string): void {
    if (!stepId) {
      return;
    }

    let openSubSection = null;
    let openStep = null;

    this.subSections.forEach((subSection) => {
      subSection.steps.forEach((stp) => {
        const isOpen = String(stp.stepId) === stepId;
        stp.accordionOpen = isOpen;
        if (isOpen) {
          openSubSection = subSection;
          openStep = stp;
        }
      });
    });

    if (openStep && openSubSection) {
      this.currentBreadcrumb = {
        sectionName: this.selectedSection?.sectionName || '',
        subSectionName: openSubSection?.subSectionName || '',
        stepName: openStep?.stepBody || '',
        isVisible: true
      };
    }
  }

  /**
   * Restores right scroll position
   */
 private restoreRightScrollPosition(scrollTop = this.lastRightScrollTop) {
    this.ngZone.runOutsideAngular(() => {
      [0, 50, 150, 300].forEach((delay) => {
        setTimeout(() => {
          const container = this.getLiveRightScrollContainer();
          if (!container) {
            return;
          }

          const maxScrollTop = Math.max(0, container.scrollHeight - container.clientHeight);
          container.scrollTop = Math.min(scrollTop, maxScrollTop);
        }, delay);
      });
    });
  }

  /**
   * Opens machine mode conflict modal
   * 
   * @param data 
   */
  public async openMachineModeConflictModal(data, ids) {
    const popover = this.modalController.create({
      component: MachineModeConflictComponent,
      cssClass: 'mango-dashboard-customization-modal',
      componentProps: { data },
    });
    popover.then((m) => m.present());
    (await popover).onWillDismiss().then((data) => {
      if (data?.data.action === 'import') {
        this.importSelectedRoadmap(ids);
      }
    });
  }

  /**
   * Checks conflict and imports roadmap
   */
  public async checkConflictAndImport() {
    this.getMachineModesForRoadmapSync();
  }

  /**
   * Gets machine modes for roadmap sync
   */
  public getMachineModesForRoadmapSync() {
    const payload = {
      roadmapIds: this.selectedRoadmapList,
      currentMachineId: this.machineId
    };
    this.backendService.fetchMachineModesForRoadmapSync(payload).subscribe({
      next: (res: any) => {
        if (res.statusCode === 200) {
          console.log(res);
          if (res.response?.newModes?.some(mode => mode.isNotFound)) {
             const ids = (res.response?.newModes ?? [])
            .filter(mode => mode.isNotFound)
            .map(mode => mode.modeId);
            console.log(ids, 'ids in roadmap view');
            this.openMachineModeConflictModal(res, ids);
          } else {
            this.importSelectedRoadmap();
          }
        }
      },
      error: (err) => {
        console.log(err);
      }
    });
  }

  /**
   * Handles image name change for roadmap images
   * Updates the media array in the step and calls API to save
   * @param image - The image object being edited
   * @param type - 'compliant' or 'notCompliant'
   * @param step - The step containing the media
   * @param subSection - The subsection containing the step
   * @param selectedSection - The selected section
   */
  public onRoadmapImageNameChange(image: any, type: string, step: any, subSection: any, selectedSection: any): void {
    if (image.is_view || this.isReadonlyRoadmap) {
      return;
    }

    // Trim the image name
    const newFileName = image.fileName ? image.fileName.trim() : '';
    
    // If the name is empty or only spaces, restore the original name without API call
    if (!newFileName) {
      image.fileName = image._originalFileName || image.fileName;
      return;
    } else {
      image.fileName = newFileName;
    }

    // Validate image name length before API call
    if (newFileName.length > 100) {
      this.toastService.presentToast(
        this.translate.instant('image_name_validation'),
        4000,
        AppConstants.ERROR_SNACKBAR,
        'top'
      );
      image.fileName = image._originalFileName || image.fileName;
      return;
    }

    // Check if value actually changed (compare with stored original)
    if (image._originalFileName === image.fileName) {
      // No change, don't call API
      return;
    }

    if (this.isDuplicateRoadmapImageName(step, image.fileName, type, image)) {
      image.fileName = image._originalFileName || image.fileName;
      this.toastService.presentToast(
        this.translate.instant('image_name_already_exist'),
        4000,
        AppConstants.WARNING_SNACKBAR,
        'top'
      );
      return;
    }

    // Update the image in the step.media array
    const mediaIndex = step.media.findIndex(m => m.id === image.id && m.url === image.url);
    if (mediaIndex !== -1) {
      step.media[mediaIndex].fileName = image.fileName;
    }

    // Don't update _originalFileName here - it will be updated after successful save
    // Call API to save the updated image name
    this.onSave(step, subSection, selectedSection, undefined, undefined, undefined, true);
  }

  public onRoadmapImageNameBlur(image: any, type: string, step: any, subSection: any, selectedSection: any, event?: FocusEvent): void {
    this.rememberPendingFocusFromTarget(event?.relatedTarget || null);
    this.onRoadmapImageNameChange(image, type, step, subSection, selectedSection);
  }

  /**
   * Stores the original image name when user focuses on the input
   * @param image - The image object being edited
   */
  public onRoadmapImageNameFocus(image: any, type: string, step: any, subSection: any, event?: FocusEvent): void {
    // Always store the current fileName when focusing, so we can restore it if save fails
    image._originalFileName = image.fileName || '';
    this.rememberPendingFocus('image-upload', subSection, step, type === 'compliant' ? 5 : 6, image);
    this.rememberImageRestoreTarget(subSection, step, type === 'compliant' ? 5 : 6, image);
  }

  public trackByImageId(index: number, item: any): any {
    return item?.id || item?.url || index;
  }

  public trackByIndex(index: number, item: any): number {
    return index;
  }

  public trackByItemId(index: number, item: any): any {
    return item?.id || item?.subSectionId || item?.sectionId || index;
  }
}